
(function() {
  var PIN = '2026';
  var stored = sessionStorage.getItem('jori_auth');
  if (stored !== 'ok') {
    var input = prompt('?? �rea restrita Jori Papel.\nDigite o PIN de acesso:');
    if (input !== PIN) {
      window.location.href = '/';
      return;
    }
    sessionStorage.setItem('jori_auth', 'ok');
  }
})();

/* === NEXT BLOCK === */

const PRODUCTS = [
{cat:"Santher",code:"ITI10",name:"Toalha Folha Tripla (PCT 200)",esp:26.9,prom:18.81},
{cat:"Santher",code:"PHI10",name:"Higiênico Kai-Kai (PCT 600)",esp:14.9,prom:10.31},
{cat:"Santher",code:"HGAB06800",name:"Álcool Gel 70% 6x800ml HGAB",esp:224.46,prom:189.93},
{cat:"Santher",code:"HGAQ06800",name:"Álcool Gel 70% Quartz 6x800",esp:416.9,prom:379.5},
{cat:"Santher",code:"SEAQ06800",name:"Antisséptico Quartz SEAQ06x800",esp:302.25,prom:255.75},
{cat:"Santher",code:"ABH06",name:"Antisséptico Bucal 1 Litro",esp:58.5,prom:49.5},
{cat:"Santher",code:"ETB20",name:"Bobina 29G 8x250m 2000M ETB20",esp:299,prom:269,comod:269},
{cat:"Santher",code:"RTB01",name:"Bobina Reviva 6x200M",esp:209.9,prom:199.65},
{cat:"Santher",code:"GGD23",name:"Guard Snob FD 64x50 23,5x23,5 (CX)",esp:349.05,prom:295.35},
{cat:"Santher",code:"GST23",name:"Guard Santepel 24x22 80x50 (CX)",esp:161.9,prom:155.1},
{cat:"Santher",code:"GST33",name:"Guard Santepel 33x30 48x50 (CX)",esp:241.8,prom:204.6},
{cat:"Santher",code:"GGD33",name:"Guard Snob FD 48x50 32,5x32,5 (CX)",esp:571.35,prom:483.45},
{cat:"Santher",code:"GGP33PCT",name:"Guard Snob FD 33 PCT 50und",esp:15.6,prom:13.2},
{cat:"Santher",code:"GSP23PCT",name:"Guard Santepel 24x22 c/50und",esp:2.92,prom:2.47},
{cat:"Santher",code:"GSP33PCT",name:"Guard Santepel 33x30 c/50und",esp:6.24,prom:5.28},
{cat:"Santher",code:"GGP23PCT",name:"Guard Snob FD 23 PCT 50und",esp:6.82,prom:5.77},
{cat:"Santher",code:"IGL24",name:"Guard Lanche IGL-24 21,6x11 20x720",esp:312,prom:264},
{cat:"Santher",code:"PHI12",name:"Hig Kai-Kai 20x600 PHI12 Personal",esp:213.9,prom:169.9,comod:169.9},
{cat:"Santher",code:"HPS45",name:"Hig Personal FS 15x04 30M HPS45",esp:89.7,prom:75.9},
{cat:"Santher",code:"PVN44",name:"Hig Personal VIP FD 16x04 30M",esp:112.9,prom:108.35},
{cat:"Santher",code:"PVC11",name:"Hig Personal Vipinho 12 Rolos",esp:20.9,prom:19.8},
{cat:"Santher",code:"EHR50",name:"Hig Rolão 100% 8x500 EHR50",esp:159.9,prom:125.5,comod:125.5},
{cat:"Santher",code:"PHR25",name:"Hig Rolão FD 08x250 PHR-25",esp:128.9,prom:101.9,comod:101.9},
{cat:"Santher",code:"LFA50",name:"Lenço Kiss c/50fls LFA50",esp:5.2,prom:4.95},
{cat:"Santher",code:"SECP06800",name:"Sabonete Foam Luna Espuma SECP06x800",esp:170.9,prom:129.9,comod:129.9},
{cat:"Santher",code:"SECQ06",name:"Sabonete Quartz Luna Espuma SECQ06x800",esp:305.9,prom:229.9,comod:229.9},
{cat:"Santher",code:"HSAP06800",name:"Spray Antisséptico HSAP06 VIX 6x800ml",esp:269.9,prom:239.25},
{cat:"Santher",code:"ITI02",name:"Toalha ITI02 FD 10x240 42G",esp:167.9,prom:132.5,comod:132.5},
{cat:"Santher",code:"ITI03",name:"Toalha ITI03 F Tripla 46G 12x200",esp:195.9,prom:154.5,comod:154.5},
{cat:"Santher",code:"ETI21",name:"Toalha ETI-21 21x21,5 CXA 06x350",esp:80.9,prom:77.55},
{cat:"Santher",code:"TNB22",name:"Toalha Cozinha Snob 02rls TNB22",esp:9.16,prom:7.75},
{cat:"Santher",code:"ETI00",name:"Toalha Eco 22x23 3D 06x400 29G",esp:102.9,prom:86.5,comod:86.5},
{cat:"Santher",code:"RTI01",name:"Toalha Interfolha Reviva 6x400",esp:104.9,prom:99},
{cat:"Santher",code:"TSP04",name:"Toalha Intf Quadr 72G 1200fls TSP04",esp:203.9,prom:196.35},
{cat:"Santher",code:"ITI01",name:"Toalha ITI01 FS 10x240 37G",esp:136.9,prom:108.9,comod:108.9},
{cat:"Santher",code:"LDAL200",name:"Toalheiro Bobina Alavanca LDAL200",esp:175.3,prom:148.33},
{cat:"Santher",code:"WPS54",name:"Wiper Dobr Sanno 29,5x32,5 PC 100",esp:60.45,prom:51.15},
{cat:"Santher",code:"WPS50",name:"Wiper Sanno Rolo 50GM2 800 Folhas",esp:390,prom:330},
{cat:"Santher",code:"WPS70",name:"Wiper Snob Rolo 70GM2 100 Folhas",esp:60.45,prom:51.15},
{cat:"Jopel/Indaial",code:"JOPEL03",name:"Bobina Jopel Alavanca Fit 06rl 100%",esp:72.9,prom:69.96},
{cat:"Jopel/Indaial",code:"JOPEL04",name:"Bobina Jopel Auto Corte 06 100%",esp:87.9,prom:84.15},
{cat:"Jopel/Indaial",code:"DIV270",name:"Guard Sachê 1000x2 2.000fls 33x14",esp:124.8,prom:105.6},
{cat:"Jopel/Indaial",code:"GUA09",name:"Guardanapo Balcão Pérola 13x14 2.000und",esp:15.99,prom:13.53},
{cat:"Jopel/Indaial",code:"IPEL06",name:"Hig Rolão 8x300m Premium Natureza Indaial",esp:75.9,prom:72.93},
{cat:"Jopel/Indaial",code:"JOPEL21",name:"Hig Rolão Girassol Luxo-Premium 08 Rolos",esp:32.9,prom:31.18},
{cat:"Jopel/Indaial",code:"JOPEL02",name:"Hig Rolão Jopel 100% Celulose c/8",esp:41.9,prom:39.6},
{cat:"Jopel/Indaial",code:"IPEL01",name:"Higiênico Interfolha FD CXA 8.000 Ipel",esp:99.9,prom:91.24},
{cat:"Jopel/Indaial",code:"IPEL02",name:"Toalha Laminado 22,5x20,5 2000F Dupla",esp:90.9,prom:87.45},
{cat:"Jopel/Indaial",code:"TOA77",name:"Toalha 100% 20x20 Nobre Slim 1.000fls",esp:18.9,prom:18.08},
{cat:"Jopel/Indaial",code:"JOPEL10",name:"Toalha 20x21 CX 2000 Jopel-10 Premium",esp:37.9,prom:36.13},
{cat:"Jopel/Indaial",code:"JOPEL06",name:"Toalha 21x19 Fardo 1.000 Qualipaper Prem",esp:15.9,prom:14.52},
{cat:"Jopel/Indaial",code:"JOPEL20",name:"Toalha Allpapers Luxo-Premium Fardo",esp:9.9,prom:9.07},
{cat:"Jopel/Indaial",code:"TOA50",name:"Toalha FD 23x21 CX 2000 10x200 Nobre",esp:109.9,prom:99},
{cat:"Jopel/Indaial",code:"JOPEL01",name:"Toalha Jopel 100% Celul 21x19 24G",esp:12.9,prom:11.22},
{cat:"Sacos de Lixo",code:"COT16",name:"Lixo 100L Azul 100und L.L.",esp:36.71,prom:31.06},
{cat:"Sacos de Lixo",code:"SAC11",name:"Lixo 100L Extra 100und Plast 40kg",esp:70.78,prom:59.89},
{cat:"Sacos de Lixo",code:"SAC105",name:"Lixo 100L Forte Amarelo 100und 25kg",esp:82.05,prom:69.43},
{cat:"Sacos de Lixo",code:"SAC15",name:"Lixo 100L Forte 100und 25kg L.F.",esp:44.9,prom:42.73},
{cat:"Sacos de Lixo",code:"SAC103",name:"Lixo 100L Forte Laranja 100und 25kg",esp:82.05,prom:69.43},
{cat:"Sacos de Lixo",code:"SAC107",name:"Lixo 100L Forte Verde 100und 25kg",esp:82.05,prom:69.43},
{cat:"Sacos de Lixo",code:"SAC52",name:"Lixo 100L Forte Transparente 100und",esp:64.35,prom:54.45},
{cat:"Sacos de Lixo",code:"SAC46",name:"Lixo 100L Infectante 100und L.L.",esp:68.25,prom:57.75},
{cat:"Sacos de Lixo",code:"SAC04",name:"Lixo 100L L.L. 100und 20kg",esp:35.9,prom:34.22},
{cat:"Sacos de Lixo",code:"SAC14",name:"Lixo 100L L.L. 100und",esp:32.44,prom:27.45},
{cat:"Sacos de Lixo",code:"SAC06",name:"Lixo 100L Pesado 100und 30kg L.P.",esp:53.9,prom:51.39},
{cat:"Sacos de Lixo",code:"PLAST100",name:"Lixo 100L Plastimaq Forte 100und",esp:54.9,prom:49.59},
{cat:"Sacos de Lixo",code:"SAC125",name:"Lixo 100L Transparente L.L. 100und",esp:36.81,prom:31.15},
{cat:"Sacos de Lixo",code:"SAC56",name:"Lixo 100L Verde 100und L.L.",esp:46.8,prom:39.6},
{cat:"Sacos de Lixo",code:"SAC17",name:"Lixo 100L Branco 100und (75x85) L.L.",esp:36.71,prom:31.06},
{cat:"Sacos de Lixo",code:"SAC19",name:"Lixo 200L Azul 100und (85x100) L.L.",esp:46.25,prom:39.13},
{cat:"Sacos de Lixo",code:"SAC34",name:"Lixo 200L Extra 100und 40kg",esp:109.39,prom:92.56},
{cat:"Sacos de Lixo",code:"SAC123",name:"Lixo 200L Forte 100und 25kg L.F.",esp:65.9,prom:57.09},
{cat:"Sacos de Lixo",code:"SAC145",name:"Lixo 200L Forte Amarelo 100und 25kg",esp:105.49,prom:89.26},
{cat:"Sacos de Lixo",code:"SAC146",name:"Lixo 200L Forte Azul 100und 25kg",esp:105.49,prom:89.26},
{cat:"Sacos de Lixo",code:"SAC150",name:"Lixo 200L Forte Laranja 100und 25kg",esp:105.49,prom:89.26},
{cat:"Sacos de Lixo",code:"SAC147",name:"Lixo 200L Forte Verde 100und 25kg",esp:105.49,prom:89.26},
{cat:"Sacos de Lixo",code:"SAC54",name:"Lixo 200L Forte Transparente 100und",esp:79.11,prom:66.94},
{cat:"Sacos de Lixo",code:"SAC44",name:"Lixo 200L Infectante 100und L.L.",esp:107.25,prom:90.75},
{cat:"Sacos de Lixo",code:"SAC200",name:"Lixo 200L L.L. 100und",esp:45.63,prom:38.61},
{cat:"Sacos de Lixo",code:"SAC05",name:"Lixo 200L Pesado 100und 30kg L.P.",esp:71.9,prom:68.47},
{cat:"Sacos de Lixo",code:"SAC132",name:"Lixo 200L Marrom L.L. 100und",esp:46.25,prom:39.13},
{cat:"Sacos de Lixo",code:"PLAST200",name:"Lixo 200L Plastimaq Forte 100und",esp:72.9,prom:66.11},
{cat:"Sacos de Lixo",code:"SAC98",name:"Lixo 200L Transparente L.L. 100und",esp:62.4,prom:52.8},
{cat:"Sacos de Lixo",code:"SAC57",name:"Lixo 200L Verde 100und L.L.",esp:43.27,prom:36.61},
{cat:"Sacos de Lixo",code:"SAC131",name:"Lixo 200L Vermelho L.L. 100und",esp:43.27,prom:36.61},
{cat:"Sacos de Lixo",code:"SAC31",name:"Lixo 200L Branco 100und (85x100)",esp:43.27,prom:36.61},
{cat:"Sacos de Lixo",code:"SAC16",name:"Lixo 200L Reforçado 100und 20kg",esp:63.9,prom:49.5},
{cat:"Sacos de Lixo",code:"SAC42",name:"Lixo 20L Azul 100und L.L.",esp:13.65,prom:11.55},
{cat:"Sacos de Lixo",code:"SAC20",name:"Lixo 20L Branco 100und L.L.",esp:14.5,prom:12.27},
{cat:"Sacos de Lixo",code:"SAC70",name:"Lixo 20L Forte Preto 100und Plast",esp:12.09,prom:10.23},
{cat:"Sacos de Lixo",code:"SAC49",name:"Lixo 20L Infectante 100und L.L.",esp:31.2,prom:26.4},
{cat:"Sacos de Lixo",code:"SAC10",name:"Lixo 20L Preto 100und L.L.",esp:10.92,prom:9.24},
{cat:"Sacos de Lixo",code:"SAC55",name:"Lixo 20L Transparente 100und L.L.",esp:13.65,prom:11.55},
{cat:"Sacos de Lixo",code:"SAC124",name:"Lixo 240L Azul Pesado 100und",esp:195,prom:165},
{cat:"Sacos de Lixo",code:"SAC07",name:"Lixo 240L Pesado 50und 35kg L.P.",esp:69.9,prom:66.18},
{cat:"Sacos de Lixo",code:"SAC300",name:"Lixo 300L 100und L.L.",esp:76.14,prom:64.43},
{cat:"Sacos de Lixo",code:"SAC01",name:"Lixo 300L Extra 50und 45kg",esp:117.19,prom:99.16},
{cat:"Sacos de Lixo",code:"SAC99",name:"Lixo 300L Forte 100und 30kg",esp:99.9,prom:96.44},
{cat:"Sacos de Lixo",code:"SAC305",name:"Lixo 300L Forte Amarelo 100und 25kg",esp:178.24,prom:150.82},
{cat:"Sacos de Lixo",code:"SAC306",name:"Lixo 300L Forte Azul 100und 25kg",esp:178.24,prom:150.82},
{cat:"Sacos de Lixo",code:"SAC303",name:"Lixo 300L Forte Laranja 100und 25kg",esp:178.24,prom:150.82},
{cat:"Sacos de Lixo",code:"SAC307",name:"Lixo 300L Forte Verde 100und 25kg",esp:178.24,prom:150.82},
{cat:"Sacos de Lixo",code:"SAC330",name:"Lixo 300L L.L. 100und 25kg",esp:105.9,prom:82.5},
{cat:"Sacos de Lixo",code:"SAC37",name:"Lixo 300L Pesado 50und 35kg L.F.",esp:60.9,prom:57.86},
{cat:"Sacos de Lixo",code:"SAC38",name:"Lixo 300L Pesado 50und 35kg L.P.",esp:97.5,prom:82.5},
{cat:"Sacos de Lixo",code:"SAC02",name:"Lixo 300L Pesado 50und 40kg L.P.",esp:92.43,prom:78.21},
{cat:"Sacos de Lixo",code:"PLAST300",name:"Lixo 300L Plastimaq Forte 100und",esp:122.9,prom:111.72},
{cat:"Sacos de Lixo",code:"SAC240",name:"Lixo 300L Transparente L.L. 100und",esp:107.25,prom:90.75},
{cat:"Sacos de Lixo",code:"SAC310",name:"Lixo 350L Super Pesado 50und",esp:154.05,prom:130.35},
{cat:"Sacos de Lixo",code:"SAC82",name:"Lixo 40L Amarelo 100und L.L.",esp:14.04,prom:11.88},
{cat:"Sacos de Lixo",code:"SAC39",name:"Lixo 40L Azul 100und L.L.",esp:14.05,prom:11.89},
{cat:"Sacos de Lixo",code:"SAC24",name:"Lixo 40L Branco 100und L.L.",esp:16.32,prom:13.81},
{cat:"Sacos de Lixo",code:"SAC85",name:"Lixo 40L Forte Amarelo 100und",esp:34.14,prom:28.89},
{cat:"Sacos de Lixo",code:"SAC86",name:"Lixo 40L Forte Azul 100und",esp:34.14,prom:28.89},
{cat:"Sacos de Lixo",code:"SAC89",name:"Lixo 40L Forte Cinza 100und",esp:34.14,prom:28.89},
{cat:"Sacos de Lixo",code:"SAC88",name:"Lixo 40L Forte Marrom 100und",esp:34.14,prom:28.89},
{cat:"Sacos de Lixo",code:"SAC71",name:"Lixo 40L Forte Preto 100und",esp:24.99,prom:21.15},
{cat:"Sacos de Lixo",code:"SAC87",name:"Lixo 40L Forte Verde 100und",esp:34.14,prom:28.89},
{cat:"Sacos de Lixo",code:"SAC84",name:"Lixo 40L Forte Vermelho 100und",esp:34.14,prom:28.89},
{cat:"Sacos de Lixo",code:"SAC61",name:"Lixo 40L Infectante 100und L.L.",esp:39,prom:33},
{cat:"Sacos de Lixo",code:"SAC12",name:"Lixo 40L Preto 100und L.L.",esp:13.06,prom:11.05},
{cat:"Sacos de Lixo",code:"SAC59",name:"Lixo 40L Transparente 100und L.L.",esp:20.47,prom:17.32},
{cat:"Sacos de Lixo",code:"SAC48",name:"Lixo 40L Verde 100und L.L.",esp:17.12,prom:14.48},
{cat:"Sacos de Lixo",code:"SAC126",name:"Lixo 40L Vermelho 100und L.L.",esp:14.04,prom:11.88},
{cat:"Sacos de Lixo",code:"SAC401",name:"Lixo 60L Amarelo 100und L.L.",esp:23.55,prom:19.93},
{cat:"Sacos de Lixo",code:"SAC40",name:"Lixo 60L Azul 100und L.L.",esp:20.28,prom:17.16},
{cat:"Sacos de Lixo",code:"SAC35",name:"Lixo 60L Branco 100und L.L.",esp:23.2,prom:19.63},
{cat:"Sacos de Lixo",code:"SAC135",name:"Lixo 60L Forte Amarelo 100und",esp:49,prom:41.46},
{cat:"Sacos de Lixo",code:"SAC120",name:"Lixo 60L Forte Colorido 100und",esp:49,prom:41.46},
{cat:"Sacos de Lixo",code:"SAC140",name:"Lixo 60L Forte Laranja 100und",esp:49,prom:41.46},
{cat:"Sacos de Lixo",code:"SAC138",name:"Lixo 60L Forte Marrom 100und",esp:49,prom:41.46},
{cat:"Sacos de Lixo",code:"SAC72",name:"Lixo 60L Forte Preto 100und",esp:35,prom:29.61},
{cat:"Sacos de Lixo",code:"SAC137",name:"Lixo 60L Forte Verde 100und",esp:49,prom:41.46},
{cat:"Sacos de Lixo",code:"SAC134",name:"Lixo 60L Forte Vermelho 100und",esp:49,prom:41.46},
{cat:"Sacos de Lixo",code:"SAC47",name:"Lixo 60L Infectante 100und L.L.",esp:52.65,prom:44.55},
{cat:"Sacos de Lixo",code:"SAC400",name:"Lixo 60L Marrom 100und L.L.",esp:23.55,prom:19.93},
{cat:"Sacos de Lixo",code:"SAC13",name:"Lixo 60L Preto 100und L.L.",esp:19.11,prom:16.17},
{cat:"Sacos de Lixo",code:"SAC03",name:"Lixo 60L Transparente 100und L.L.",esp:23.4,prom:19.8},
{cat:"Sacos de Lixo",code:"SAC43",name:"Lixo 60L Verde 100und L.L.",esp:27.3,prom:23.1},
{cat:"Sacos de Lixo",code:"SAC121",name:"Lixo 60L Vermelho 100und L.L.",esp:23.55,prom:19.93},
{cat:"Spartan",code:"SPA40",name:"Desinfetante Uso Geral 5L (MCD-50)",esp:177.9,prom:161.7},
{cat:"Spartan",code:"SPA11",name:"Álcool Gel Spartan Bombona 4,4kg",esp:68.25,prom:57.75},
{cat:"Spartan",code:"SPA12",name:"Bomba Manual Dosadora + Tampa",esp:44.85,prom:37.95},
{cat:"Spartan",code:"SPA07",name:"Desincrustante Alcalino Foaming 5L",esp:114.9,prom:103.95},
{cat:"Spartan",code:"SPA14",name:"Desinf Neutral NABC Bouquet 5L",esp:41.9,prom:37.95},
{cat:"Spartan",code:"SPA22",name:"Desinfetante Conc. MLD Floral 1:100 5L",esp:67.9,prom:61.05},
{cat:"Spartan",code:"SPA08",name:"Deterg Conc Neutro Golden Glo 5L",esp:76.9,prom:69.3},
{cat:"Spartan",code:"SPA23",name:"Foaming Antibac Hand Sanitizer 1.250ml",esp:66.3,prom:56.1},
{cat:"Spartan",code:"SPA10",name:"Sabonete Erva Doce 12x800ml Xpress",esp:169.65,prom:143.55},
{cat:"Spartan",code:"SPA16",name:"Sabonete Xpress Hidratante 5L",esp:54.9,prom:49.5},
{cat:"Spartan",code:"SPA21",name:"Suporte p/ Instalação Sab Espuma",esp:15.6,prom:13.2},
{cat:"Acessórios",code:"DEB20",name:"Dispenser Enxaguante Bucal 3 em 1 Preto",esp:195,prom:165},
{cat:"Acessórios",code:"DGL06",name:"Dispenser Guard Lanche Cristal DGL06",esp:195,prom:165},
{cat:"Acessórios",code:"DHA400",name:"Dispenser Higienizador Assento Sanit",esp:195,prom:165},
{cat:"Acessórios",code:"KSF07",name:"Kit Saboneteira Espuma Santher",esp:195,prom:165},
{cat:"Acessórios",code:"FORT80",name:"Toalheiro Mazzo LMTI600EX Forcom",esp:35.1,prom:29.7},
{cat:"Acessórios",code:"DIV200",name:"Saboneteira Nobre Sem Res p/ BAG",esp:33.15,prom:28.05},
{cat:"Acessórios",code:"SANMMK0620",name:"Válvula Saboneteira Foam Santher",esp:50.7,prom:42.9},
{cat:"Álcool",code:"MAT71",name:"Álcool Barrica Gel Archott 10kg",esp:106.9,prom:99},
{cat:"Álcool",code:"TOP11",name:"Álcool Gel Pump Antis 70% 440gr",esp:7.99,prom:6.76},
{cat:"Álcool",code:"TOP45",name:"Álcool Gel 70 Dragogo Frasco 500gr",esp:7.6,prom:6.43},
{cat:"Álcool",code:"TOP12",name:"Álcool Gel 70% BAG 800ml Top Bel",esp:11.68,prom:9.88},
{cat:"Álcool",code:"PRING01",name:"Álcool Pring 70 CXA 12L Hospitalar",esp:89.9,prom:90.75},
{cat:"Álcool",code:"TUP02",name:"Limpador Hospitalar 70 Litro 1.000ml",esp:11.7,prom:9.9},
{cat:"Álcool",code:"MAT50",name:"Limpador Hospitalar 70 Pack 06L",esp:47.9,prom:46.2},
{cat:"Alumínio",code:"DIV35",name:"Papel Alumínio Rolão 100mx0,30cm",esp:62.4,prom:52.8},
{cat:"Alumínio",code:"DIV13",name:"Papel Alumínio Rolinho 7,5x0,30",esp:5.26,prom:4.45},
{cat:"Alumínio",code:"DIV72",name:"Quentinha Manual N.09 100und",esp:78,prom:66},
{cat:"Alumínio",code:"DIV12",name:"Quentinha p/Maquina N.08 c/100und",esp:68.25,prom:57.75},
{cat:"Alumínio",code:"DIV73",name:"Quentinha p/Maquina N.09 c/100und",esp:78,prom:66},
{cat:"Archote",code:"SAB52",name:"Álcool Gel 70% Mollis Bombona 5L",esp:47.9,prom:42.9},
{cat:"Archote",code:"ARC01",name:"Desinf Neutr Deep Wash 1:20 Lavanda 5L",esp:39.9,prom:36.36},
{cat:"Archote",code:"ARC05",name:"Desinfetante Cleene Lavanda 5L",esp:15.9,prom:13.69},
{cat:"Archote",code:"ARC08",name:"Detergente Agifacil Neutro 500ml",esp:2.99,prom:2.67},
{cat:"Archote",code:"ARC02",name:"Detergente Clorado Agipro Concent 5L",esp:56.9,prom:51.29},
{cat:"Archote",code:"ARC41",name:"Limpa Limo Agifacil 500ml",esp:6.82,prom:5.77},
{cat:"Archote",code:"ARC46",name:"Limpador Mult Flotador Hiperflot 5L",esp:59.9,prom:54.45},
{cat:"Archote",code:"ARC50",name:"Limpador Multiuso Original 500ml Archote",esp:4.59,prom:4.12},
{cat:"Becker",code:"HEAT06800",name:"Álcool-Gel Titanium HGAT06800 Santher",esp:277.9,prom:252.45},
{cat:"Becker",code:"BEC32",name:"Desincr Deseng Versátil AL2050 5L",esp:74.9,prom:66},
{cat:"Becker",code:"BEC35",name:"Detergente Clorobecker Spuma 5L",esp:83.85,prom:70.95},
{cat:"Becker",code:"BEC02",name:"Detergente Versátil Beckerplater 5L",esp:33.15,prom:28.05},
{cat:"Mat. Limpeza",code:"ARC45",name:"Cera Agipro Evol Acabam Acrílico 3x1 5L",esp:214.5,prom:181.5},
{cat:"Mat. Limpeza",code:"VAS50",name:"Mop Úmido Pressão Ponta Dobrada 330gr",esp:25.35,prom:21.45},
{cat:"Diversos",code:"MAT149",name:"Café Melita 500g",esp:62.9,prom:57.75},
{cat:"Copos",code:"COP61",name:"Copo 200 PP Cristal Branco 25x100und",esp:166.9,prom:156.75},
{cat:"Copos",code:"COP29",name:"Copo 200 PP Cristal Transp 25x100und",esp:166.9,prom:156.75},
{cat:"Copos",code:"COP27",name:"Copo 180 Isopor 1000und Ultra",esp:351,prom:297},
{cat:"Copos",code:"COP16",name:"Copo 200 Cristal PS Branco 25x100und",esp:139.9,prom:132},
{cat:"Copos",code:"COP11",name:"Copo 200 Cristal PS Transp 25x100und",esp:139.9,prom:132},
{cat:"Copos",code:"COT09",name:"Copo 200 Transp 1.000und Nobre",esp:175.5,prom:148.5},
{cat:"Copos",code:"COP37",name:"Copo 200ml PP Tira PCT 100und",esp:9.75,prom:8.25},
{cat:"Copos",code:"COP44",name:"Copo 300ml Isopor 1000und",esp:390,prom:330},
{cat:"Copos",code:"COP01",name:"Copo 400ml Transp Fonplast 1.000und",esp:208.65,prom:176.55},
{cat:"Copos",code:"COP04",name:"Copo 500 Transparente 20x50und",esp:243.75,prom:206.25},
{cat:"Copos",code:"COT17",name:"Copo Café Tira 50ml PS PCT 100und",esp:3.9,prom:3.3},
{cat:"Copos",code:"COP45",name:"Copo Café 120 Isopor 1000und",esp:331.5,prom:280.5},
{cat:"Copos",code:"COP19",name:"Copo Café 50 Cristal Copo 50x100und",esp:149.77,prom:126.73},
{cat:"Copos",code:"COP05",name:"Copo Café 80 Cristalcopo 25x100und",esp:156,prom:132},
{cat:"Copos",code:"COP24",name:"Copo Chopp 300 Fonplast PS 20x100und",esp:214.5,prom:181.5},
{cat:"Copos",code:"COP41",name:"Copo Chopp 300ml PS Tira PCT 100und",esp:13.65,prom:11.55},
{cat:"Copos",code:"COP20",name:"Pote 100ml Cristal Copo Transp 40x50und",esp:136.5,prom:115.5},
{cat:"Copos",code:"COP15",name:"Tampa 100ml Copozan Transp 40x50und",esp:171.67,prom:145.26},
{cat:"Copos",code:"COP43",name:"Tampa 180ml p/ Copo Isopor 1.000und",esp:214.5,prom:181.5},
{cat:"Copos",code:"COP90",name:"Tampa 300ml Cristal Copo 40x50und",esp:156,prom:132},
{cat:"Mat. Limpeza",code:"DES04",name:"Desinf Germicida Bactericida Mazocresol 1L",esp:17.9,prom:13.18},
{cat:"Mat. Limpeza",code:"COR20",name:"Desinf Lavanda c/ 5L Cordex",esp:11.31,prom:9.57},
{cat:"Diversos",code:"MAT300",name:"Açúcar Caravelas 1kg Fardo 10PCT",esp:81.9,prom:77.55},
{cat:"Diversos",code:"MAT190",name:"Açúcar União Sachê c/ 400und",esp:42.9,prom:36.3},
{cat:"Diversos",code:"DIV222",name:"Canudo Papel 06mm 100und Branco",esp:9.5,prom:8.58},
{cat:"Diversos",code:"SAB24",name:"Coletor Absorvente 25und Obeg",esp:14.62,prom:12.37},
{cat:"Diversos",code:"COT03",name:"Dedeira c/100und",esp:19.2,prom:16.25},
{cat:"Diversos",code:"DIV59",name:"Disco 350 Limpador Verde 3M",esp:28.29,prom:23.94},
{cat:"Diversos",code:"BET61",name:"Disco 350 Removedor Preto Bettanin",esp:35.1,prom:29.7},
{cat:"Diversos",code:"BET81",name:"Disco 410 Preto Bettanin",esp:48.75,prom:41.25},
{cat:"Diversos",code:"DQI20",name:"Dispenser Toalha Interf Mini Quartz",esp:130.02,prom:110.02},
{cat:"Diversos",code:"FAST008",name:"Embalagem S-10 c/ 100und",esp:39,prom:33},
{cat:"Diversos",code:"DIV15",name:"Filtro de Papel 102 Brigitta",esp:6.82,prom:5.77},
{cat:"Diversos",code:"DIV16",name:"Filtro de Papel 103 Brigitta",esp:7.8,prom:6.6},
{cat:"Diversos",code:"DIV85",name:"Fita Embalagem Transp 48x4,50",esp:5.85,prom:4.95},
{cat:"Diversos",code:"DIV07",name:"Forro Compacto Sanitário 40und Velux",esp:10.86,prom:9.19},
{cat:"Diversos",code:"TOA06",name:"Fundo de Bandeja 25x36 c/500",esp:17.55,prom:14.85},
{cat:"Diversos",code:"TOA33",name:"Lençol 50cm Hospit 100% 06rl",esp:131.74,prom:111.47},
{cat:"Diversos",code:"INO90",name:"Lençol 70cm Hospit 100% 06rl",esp:175.5,prom:148.5},
{cat:"Diversos",code:"MAT84",name:"Lubrificante Super Lub Loctite 300ml",esp:48.75,prom:41.25},
{cat:"Diversos",code:"DIV93",name:"Luva Forrada XG Amarela Mucambo",esp:6.43,prom:5.44},
{cat:"Diversos",code:"COT01",name:"Máscara Cirúrgica Tripla Anvisa 50und",esp:10.58,prom:8.95},
{cat:"Diversos",code:"DIV96",name:"Mexedor de Drink 11cm 240und",esp:13.65,prom:11.55},
{cat:"Diversos",code:"DIV65",name:"Palito Dental Embalado 2.000und",esp:21.45,prom:18.15},
{cat:"Diversos",code:"DIV240",name:"Placa Sinalizadora Piso Molhado",esp:68.25,prom:57.75},
{cat:"Diversos",code:"FORT03",name:"Porta Hig Interf Kai-Kai Mazzo Extra",esp:35.1,prom:29.7},
{cat:"Diversos",code:"FORT83",name:"Porta Hig Kai-Kai LMPI500EX",esp:25.35,prom:21.45},
{cat:"Diversos",code:"FORT04",name:"Porta Hig Rolão Mazzo Extra Branco",esp:39,prom:33},
{cat:"Diversos",code:"FORT81",name:"Porta Higiênico Rolão LMPR500EX",esp:33.15,prom:28.05},
{cat:"Diversos",code:"FORT06",name:"Poupa Copo DPCD 150-200ml Automático",esp:68.25,prom:57.75},
{cat:"Diversos",code:"DIV97",name:"Pulverizador Universal 500ml",esp:6.82,prom:5.77},
{cat:"Diversos",code:"DIV49",name:"Quentinha Isopor c Tampa N8 100und 750ml",esp:54.6,prom:46.2},
{cat:"Diversos",code:"DIV86",name:"Rede Cabelo Preta PCT 100und",esp:97.5,prom:82.5},
{cat:"Diversos",code:"ORAL05",name:"Refil Fio Dental 500m Fortcom",esp:22.03,prom:18.64},
{cat:"Diversos",code:"FORT70",name:"Reservatório Fortcom",esp:37.05,prom:31.35},
{cat:"Diversos",code:"FORT31",name:"Saboneteira LDS900 Refil Gel Valvula White",esp:44.85,prom:37.95},
{cat:"Diversos",code:"FORT10",name:"Saboneteira Liq + Reserv LMSR800B Black",esp:40.95,prom:34.65},
{cat:"Diversos",code:"FORT82",name:"Saboneteira Líquida c/ Reservatório Nobre",esp:39,prom:33},
{cat:"Diversos",code:"FORT08",name:"Saboneteira Refil Espuma LDSES800",esp:35.1,prom:29.7},
{cat:"Diversos",code:"MAT96",name:"Sal Sachê 2.000und",esp:42.9,prom:36.3},
{cat:"Diversos",code:"BET300",name:"Suporte Fibra LT 9516 Bettanin",esp:25.35,prom:21.45},
{cat:"Diversos",code:"FORT50",name:"Suporte Reserv Espuma ou Spray Dropy",esp:2.14,prom:1.81},
{cat:"Diversos",code:"DIV23",name:"Tela para Mictório",esp:4.68,prom:3.96},
{cat:"Diversos",code:"TOA40",name:"Toalha Cozinha Yury Fit 02rls",esp:5.44,prom:4.6},
{cat:"Diversos",code:"INO81",name:"Toalheiro Bobina Autocut LITB17",esp:253.5,prom:214.5},
{cat:"Diversos",code:"FORT30",name:"Toalheiro Bobina Autocut LITB200 Infinity",esp:312,prom:264},
{cat:"Diversos",code:"FORT13",name:"Toalheiro Interf LMTI600B Mazzo Black",esp:48.75,prom:41.25},
{cat:"Diversos",code:"DIV36",name:"Touca Descartável 100und Vabene",esp:10.72,prom:9.07},
{cat:"Guardanapos",code:"JOPEL23",name:"Guardanapo Qualisoft 23x22 66PCx50und",esp:119.9,prom:112.2},
{cat:"Guardanapos",code:"JOPEL22",name:"Guardanapo Qualisoft 33x30 30PCx100und",esp:179.9,prom:173.25},
{cat:"Lâmpadas",code:"ELE08",name:"Lâmpada LED Bulbo A 12,0W E27",esp:8.77,prom:7.42},
{cat:"Lâmpadas",code:"ELE05",name:"Lâmpada LED Bulbo A 15,0W E27",esp:9.75,prom:8.25},
{cat:"Lâmpadas",code:"ELE09",name:"Lâmpada LED Bulbo A 6,0W E27",esp:6.82,prom:5.77},
{cat:"Lâmpadas",code:"ELE06",name:"Lâmpada LED Bulbo A 9,0W E27",esp:5.85,prom:4.95},
{cat:"Lâmpadas",code:"ELE04",name:"Lâmpada Eletrônica 127V 25wts",esp:19.5,prom:16.5},
{cat:"Lâmpadas",code:"ELE07",name:"Lâmpada LED 127V 20wts",esp:11.7,prom:9.9},
{cat:"Luvas",code:"DIV53",name:"Luva G Azul Mucambo",esp:6.24,prom:5.28},
{cat:"Luvas",code:"DIV82",name:"Luva M Azul Mucambo",esp:6.24,prom:5.28},
{cat:"Luvas",code:"DIV110",name:"Luva Mapa A-18 Cano Longo N9 G",esp:58.5,prom:49.5},
{cat:"Luvas",code:"DIV21",name:"Luva Descartável 100und",esp:2.53,prom:2.14},
{cat:"Luvas",code:"DIV50",name:"Luva Forrada G Amarela Mucambo",esp:6.2,prom:5.24},
{cat:"Luvas",code:"DIV81",name:"Luva Forrada G Nobre",esp:3.31,prom:2.8},
{cat:"Luvas",code:"DIV63",name:"Luva Forrada G Verde Mucambo",esp:6.82,prom:5.77},
{cat:"Luvas",code:"DIV47",name:"Luva Forrada M Amarela Mucambo",esp:6.2,prom:5.24},
{cat:"Luvas",code:"DIV52",name:"Luva Forrada M Nobre",esp:3.21,prom:2.72},
{cat:"Luvas",code:"DIV87",name:"Luva Forrada M Verde Mucambo",esp:6.82,prom:5.77},
{cat:"Luvas",code:"DIV92",name:"Luva Forrada XG Verde Mucambo",esp:7.8,prom:6.6},
{cat:"Luvas",code:"DIV101",name:"Luva Proced Vinil Sem Pó G 100und",esp:19.9,prom:18.15},
{cat:"Luvas",code:"DIV98",name:"Luva Procedimento Latex G Nobre 100und",esp:35.72,prom:30.22},
{cat:"Luvas",code:"DIV71",name:"Luva Procedimento Latex M Nobre 100und",esp:31.2,prom:26.4},
{cat:"Luvas",code:"DIV51",name:"Luva Viniflex G Sem Pó 100und Branca",esp:15.6,prom:13.2},
{cat:"Mat. Limpeza",code:"SAP18",name:"Sabão em Pó Sanit OMO 800gr",esp:29.25,prom:24.75},
{cat:"Mat. Limpeza",code:"SAP30",name:"Sabão em Pó Surf 1,6kg",esp:25.9,prom:23.1},
{cat:"Mat. Limpeza",code:"SAP03",name:"Sabão em Pó Surf 800gr",esp:17.55,prom:14.85},
{cat:"Mat. Limpeza",code:"COR23",name:"Água Sanitária 1.000ml Cordex",esp:3.31,prom:2.8},
{cat:"Mat. Limpeza",code:"MAT94",name:"Álcool Hosp 70 Safra Bomb 5L",esp:46.9,prom:44.55},
{cat:"Mat. Limpeza",code:"COR40",name:"Alvejante 5L Cordex",esp:11.52,prom:9.75},
{cat:"Mat. Limpeza",code:"TOP10",name:"Alvejante Top Bel 5L",esp:10.53,prom:8.91},
{cat:"Mat. Limpeza",code:"MAT136",name:"Alvejante Vanish Multiuso 1,5L Cristal",esp:50.7,prom:42.9},
{cat:"Mat. Limpeza",code:"MAT133",name:"Alvejante Vanish Multiuso 1,5L Rosa",esp:39,prom:33},
{cat:"Mat. Limpeza",code:"SAP13",name:"Amaciante Roupas Urca 2L",esp:11.7,prom:9.9},
{cat:"Mat. Limpeza",code:"MAT95",name:"Brilha Inox 3M Aerosol",esp:74.1,prom:62.7},
{cat:"Mat. Limpeza",code:"CER05",name:"Cera Brilho Fácil 750ml Incolor",esp:23.4,prom:19.8},
{cat:"Mat. Limpeza",code:"COR50",name:"Cera Incolor Brilho Inst Cordex 5L",esp:25.93,prom:21.94},
{cat:"Mat. Limpeza",code:"CER07",name:"Cera Poliflor Inc. Pratic 750ml",esp:27.3,prom:23.1},
{cat:"Mat. Limpeza",code:"MAT20",name:"Citrossauna Essência Eucalipto 1000ml",esp:48.75,prom:41.25},
{cat:"Mat. Limpeza",code:"COR11",name:"Desengordurante 5L Cordex",esp:30.34,prom:25.67},
{cat:"Mat. Limpeza",code:"COR36",name:"Desengraxante Cordex 5L",esp:40.24,prom:34.05},
{cat:"Mat. Limpeza",code:"DES99",name:"Desinf Gratty Conc. Floral 1000ml",esp:78,prom:66},
{cat:"Mat. Limpeza",code:"DES29",name:"Desinf Gratty Conc. Lavanda 1000ml",esp:63.9,prom:57.75},
{cat:"Mat. Limpeza",code:"DES11",name:"Desinf Pinho Sol Tradicional 500ml",esp:12.67,prom:10.72},
{cat:"Mat. Limpeza",code:"COR12",name:"Desinfetante Concentrado Dexmax 5L",esp:46.21,prom:39.1},
{cat:"Mat. Limpeza",code:"DES18",name:"Desinfetante Lysoform Bruto 1000ml",esp:29.25,prom:24.75},
{cat:"Mat. Limpeza",code:"TOP44",name:"Desinfetante Top Bel Lavanda 5L",esp:11.9,prom:10.06},
{cat:"Mat. Limpeza",code:"TOP06",name:"Desinfetante Top Bel Floral 5L",esp:12.28,prom:10.39},
{cat:"Mat. Limpeza",code:"TOP47",name:"Desinfetante Top Bel Talco 5L",esp:12.28,prom:10.39},
{cat:"Mat. Limpeza",code:"COR31",name:"Detergente Cordex Frasco 500ml Neutro",esp:2.29,prom:2.04},
{cat:"Mat. Limpeza",code:"TOP201",name:"Detergente Gelatinoso Top Bel 5L",esp:25.35,prom:21.45},
{cat:"Mat. Limpeza",code:"DET100",name:"Detergente Limpol Neutro 500ml",esp:3.49,prom:3.3},
{cat:"Mat. Limpeza",code:"COR51",name:"Detergente Neutro 5L Cordex",esp:16.96,prom:14.35},
{cat:"Mat. Limpeza",code:"TOP07",name:"Detergente Neutro 5L Top Bel",esp:16.57,prom:14.02},
{cat:"Mat. Limpeza",code:"DET04",name:"Detergente ODD 500ml Neutro",esp:3.49,prom:2.97},
{cat:"Mat. Limpeza",code:"MAT68",name:"Esponja Scoth Brit 10und 3M",esp:20.47,prom:17.32},
{cat:"Mat. Limpeza",code:"MAT81",name:"Esponja Tinindo 3M 10und",esp:8.77,prom:7.42},
{cat:"Mat. Limpeza",code:"MAT14",name:"Esponja de Aço Bombril Maço",esp:3.7,prom:3.13},
{cat:"Mat. Limpeza",code:"MAT89",name:"Esponja de Aço Qlustro Maço",esp:3.19,prom:2.7},
{cat:"Mat. Limpeza",code:"MAT07",name:"Essência Eucalipto 1000ml",esp:74.9,prom:71.77},
{cat:"Mat. Limpeza",code:"MAT103",name:"Fibra Fibraço 05und Tinindo-3M",esp:12.18,prom:10.31},
{cat:"Mat. Limpeza",code:"DIV62",name:"Fibra Macia Branca Tinindo 3M 06und",esp:10.33,prom:8.74},
{cat:"Mat. Limpeza",code:"MAT100",name:"Fibra Serviço Pesado 05und Tinindo-3M",esp:19.5,prom:16.5},
{cat:"Mat. Limpeza",code:"FIB06",name:"Fibra Uso Geral 06und Tinindo-3M",esp:12.67,prom:10.72},
{cat:"Mat. Limpeza",code:"DIV43",name:"Fibra Uso Geral PCT 02und 3M",esp:5.85,prom:4.95},
{cat:"Mat. Limpeza",code:"MAT75",name:"Flanela 25x40 Amarela 06und",esp:10.53,prom:8.91},
{cat:"Mat. Limpeza",code:"MAT62",name:"Flanela 40x50 Amarela 06und",esp:21.06,prom:17.82},
{cat:"Mat. Limpeza",code:"MAT63",name:"Flanela Branca 40x50 06und",esp:21.06,prom:17.82},
{cat:"Mat. Limpeza",code:"MAT104",name:"Harpic WC Lavanda 500ml",esp:19.5,prom:16.5},
{cat:"Mat. Limpeza",code:"COR98",name:"Hipoclorito Concentrado 12% 5L Cordex",esp:32.9,prom:29.7},
{cat:"Mat. Limpeza",code:"TOP02",name:"Hipoclorito Top Bel 5% 5L",esp:17.35,prom:14.68},
{cat:"Mat. Limpeza",code:"MAT80",name:"Inseticida SBP Grande Mult 450ml",esp:22.9,prom:20.62},
{cat:"Mat. Limpeza",code:"COR52",name:"Limpa Pedras Limped 5L Cordex",esp:52.65,prom:44.55},
{cat:"Mat. Limpeza",code:"MAT03",name:"Limpa Vidros Vidrex 500ml Squeeze",esp:15.6,prom:13.2},
{cat:"Mat. Limpeza",code:"DES32",name:"Limpador Casa e Perf Sensazione 1L",esp:14.82,prom:12.54},
{cat:"Mat. Limpeza",code:"MONT24",name:"Limpador Hospitalar 70 CXA 12L Montenegro",esp:129.24,prom:124.67},
{cat:"Mat. Limpeza",code:"MAT501",name:"Limpador Multiuso Original 500ml Cordex",esp:3.9,prom:3.3},
{cat:"Mat. Limpeza",code:"COR10",name:"Limpador Multiuso 5L Cordex",esp:24.47,prom:20.7},
{cat:"Mat. Limpeza",code:"MAT09",name:"Lustra Móveis Poliflor Pequeno 200ml",esp:12.9,prom:10.98},
{cat:"Mat. Limpeza",code:"DIV40",name:"Mop Úmido Nobre Refil Rosca",esp:13.24,prom:11.2},
{cat:"Mat. Limpeza",code:"MAT91",name:"Mop Úmido Pressão Ponta Dobrada 290gr",esp:19.5,prom:16.5},
{cat:"Mat. Limpeza",code:"DIV78",name:"Mop Úmido Pressão Ponta Cortada 290gr",esp:17.55,prom:14.85},
{cat:"Mat. Limpeza",code:"DEZ10",name:"Naftalina PCT",esp:4.87,prom:4.12},
{cat:"Mat. Limpeza",code:"COR37",name:"Odorizador Floral 5L Cordex",esp:26.03,prom:22.02},
{cat:"Mat. Limpeza",code:"MAT66",name:"Óleo de Peroba 200ml",esp:21.45,prom:18.15},
{cat:"Mat. Limpeza",code:"MAT15",name:"Palha de Aço N.1",esp:3.51,prom:2.97},
{cat:"Mat. Limpeza",code:"SAP04",name:"Pasta Cristal 500gr UFE",esp:7.8,prom:6.6},
{cat:"Mat. Limpeza",code:"SAP01",name:"Pasta Limpeza Dragoco 500gr",esp:5.85,prom:4.95},
{cat:"Mat. Limpeza",code:"MAT200",name:"Pastilha Adesiva Sany Lavanda 03und",esp:7.8,prom:6.6},
{cat:"Mat. Limpeza",code:"DEZ12",name:"Pedra Sanitária Sani PCT 25gr",esp:1.95,prom:1.65},
{cat:"Mat. Limpeza",code:"DEZ02",name:"Pedra Sanitária Sanifet CXA 35gr",esp:2.73,prom:2.31},
{cat:"Mat. Limpeza",code:"MAT44",name:"Polidor de Metais Brasso 200ml",esp:68.25,prom:57.75},
{cat:"Mat. Limpeza",code:"DEZ11",name:"Purif Bom Ar 03x12ml Spray Refil Lavanda",esp:52.65,prom:44.55},
{cat:"Mat. Limpeza",code:"DEZ21",name:"Purif. Bom Ar Fresh-Matic Lavanda Refil 250ml",esp:39,prom:33},
{cat:"Mat. Limpeza",code:"DEZ22",name:"Purificador Bom Ar Fresh-Matic Apar+Refil",esp:87.75,prom:74.25},
{cat:"Mat. Limpeza",code:"DEZ04",name:"Purificador Bom Ar Lavanda 360ml",esp:16.8,prom:15.67},
{cat:"Mat. Limpeza",code:"DEZ01",name:"Purificador Bom Ar Talco 360ml",esp:19.11,prom:16.17},
{cat:"Mat. Limpeza",code:"MAT28",name:"Querosene 900ml Rafbras",esp:33.15,prom:28.05},
{cat:"Mat. Limpeza",code:"MAT30",name:"Removedor 900ml Jacaré Rafbras",esp:35.1,prom:29.7},
{cat:"Mat. Limpeza",code:"SAP06",name:"Sabão de Coco Ruth 05x180gr UFE",esp:29.25,prom:24.75},
{cat:"Mat. Limpeza",code:"SAP60",name:"Sabão em Barra Minuano 05x180gr",esp:25.35,prom:21.45},
{cat:"Mat. Limpeza",code:"SAP25",name:"Sabão em Pó Espumil Lavanda Saco 04kg",esp:27.3,prom:23.1},
{cat:"Mat. Limpeza",code:"SAP05",name:"Sabão Pastoso Corcovado 500gr",esp:6.9,prom:6.6},
{cat:"Mat. Limpeza",code:"TOP50",name:"Sabonete Líquido Neutro Top Bel 5L",esp:21.45,prom:18.15},
{cat:"Mat. Limpeza",code:"TOP16",name:"Sabonete Top Espuma Top Bel 5L",esp:33.15,prom:28.05},
{cat:"Mat. Limpeza",code:"SAP16",name:"Sapolão em Pó Radium Cloro 300gr",esp:8.77,prom:7.42},
{cat:"Mat. Limpeza",code:"SAP24",name:"Saponáceo Cif Multiuso Cremoso 450ml",esp:17.9,prom:16.5},
{cat:"Mat. Limpeza",code:"MAT26",name:"Soda Cáustica Amália 400gr",esp:21.45,prom:18.15},
{cat:"Mat. Limpeza",code:"MAT42",name:"Vaselina 900ml Rafbras",esp:42.9,prom:36.3},
{cat:"Mat. Limpeza",code:"MAT41",name:"Veja Campestre 500ml",esp:7.02,prom:5.94},
{cat:"Mat. Limpeza",code:"MAT73",name:"Veja Cozinha Desengordurante 500ml",esp:16.39,prom:13.87},
{cat:"Mat. Limpeza",code:"MAT105",name:"Veja Original LP Álcool 500ml",esp:15.6,prom:13.2},
{cat:"Mat. Limpeza",code:"MAT74",name:"Veja Perfume da Natureza Lavanda 500ml",esp:7.8,prom:6.6},
{cat:"Mat. Limpeza",code:"MAT02",name:"Veja Tradicional 500ml",esp:6.24,prom:5.28},
{cat:"Mat. Limpeza",code:"MAT110",name:"Veja X-14 Limpeza Pesada Cloro 500ml",esp:14.62,prom:12.37},
{cat:"Mat. Limpeza",code:"MAT64",name:"Veja X-14 Tira-Limo Refil 500ml",esp:27.3,prom:23.1},
{cat:"Outros",code:"PAS50",name:"Forro Sanit 05x120un 35,5x44,5cm Santher",esp:175.5,prom:148.5},
{cat:"Panos",code:"DIV66",name:"Estopa Têxtil 500gr",esp:13.65,prom:11.55},
{cat:"Panos",code:"MAT08",name:"Pano 240mt Nobre Branco",esp:82.9,prom:79.2},
{cat:"Panos",code:"MAT500",name:"Pano 240mt Nobre Azul",esp:82.9,prom:77.38},
{cat:"Panos",code:"MAT65",name:"Pano 240mt Nobre Laranja",esp:82.9,prom:79.2},
{cat:"Panos",code:"MAT154",name:"Pano 28x180m Verde 600 Panos 30cm",esp:129,prom:69.13},
{cat:"Panos",code:"MAT120",name:"Pano 300x20 Azul Nobre",esp:73.9,prom:70.95},
{cat:"Panos",code:"MAT152",name:"Pano 300x20 Branco Nobre",esp:73.9,prom:70.95},
{cat:"Panos",code:"MAT151",name:"Pano 300x20 Laranja Nobre",esp:73.9,prom:70.95},
{cat:"Panos",code:"MAT11",name:"Pano 300x28cm Azul Nobre",esp:136.5,prom:115.5},
{cat:"Panos",code:"MAT153",name:"Pano 300x28cm Branco Nobre",esp:136.5,prom:115.5},
{cat:"Panos",code:"MAT156",name:"Pano 300x28cm Laranja Nobre",esp:136.5,prom:115.5},
{cat:"Panos",code:"MAT32",name:"Pano 300x28cm Verde Nobre",esp:136.5,prom:115.5},
{cat:"Panos",code:"MAT175",name:"Pano de Chão 30x55 10und CCA",esp:24,prom:23.92},
{cat:"Panos",code:"MAT90",name:"Pano de Prato Overloke 05und",esp:19.01,prom:16.08},
{cat:"Panos",code:"MAT22",name:"Pano Multi-Uso 05und",esp:2.92,prom:2.47},
{cat:"Panos",code:"MAT97",name:"Saco Alveja Extra-Plus G 43x68 10und",esp:69.9,prom:66.66},
{cat:"Panos",code:"MAT176",name:"Saco Alvejado Combate 40x60 10und",esp:30,prom:29.7},
{cat:"Panos",code:"MAT85",name:"Saco Alvejado Tradicional 43x68 10und",esp:41,prom:39.6},
{cat:"Sabonetes",code:"SECT06800",name:"Sabonete Espuma Titanium SECT06x800",esp:219.9,prom:198},
{cat:"Sabonetes",code:"SAB11",name:"Sabonete Erva-Doce CXA 06x800ml",esp:55,prom:49.5},
{cat:"Embalagens",code:"DIV75",name:"Bobina Compactador 80x100x0,07",esp:97.22,prom:82.26},
{cat:"Embalagens",code:"SAC25",name:"Bobina PIC Kromasa 20x30cm",esp:12.3,prom:10.41},
{cat:"Embalagens",code:"SAC30",name:"Bobina PIC Kromasa 25x35cm",esp:19.16,prom:16.21},
{cat:"Embalagens",code:"SAC29",name:"Bobina PIC Kromasa 30x40cm",esp:23.45,prom:19.84},
{cat:"Embalagens",code:"SAC26",name:"Bobina PIC Kromasa 40x50cm",esp:35.86,prom:30.34},
{cat:"Embalagens",code:"SAC32",name:"Bobina PIC Kromasa 40x60cm",esp:50.11,prom:42.4},
{cat:"Embalagens",code:"SAC95",name:"Bobina PIC San Marino 20x30cm",esp:8.59,prom:7.75},
{cat:"Embalagens",code:"SAC96",name:"Bobina PIC San Marino 25x35cm",esp:13.26,prom:11.22},
{cat:"Embalagens",code:"SAC97",name:"Bobina PIC San Marino 30x40cm",esp:16.39,prom:14.35},
{cat:"Embalagens",code:"SAC100",name:"Bobina PIC San Marino 40x60cm",esp:30.9,prom:28.05},
{cat:"Embalagens",code:"SAC41",name:"Bobina Picotada 50x70",esp:52.65,prom:44.55},
{cat:"Embalagens",code:"DIV68",name:"Bobina Plástica Açougue 60cm Kromasa",esp:126.8,prom:107.29},
{cat:"Embalagens",code:"COT37",name:"Filme Bobina Tecfilm PVC-40",esp:34.9,prom:33},
{cat:"Embalagens",code:"DIV45",name:"Filme Grande Bobina PVC-60",esp:97.5,prom:82.5},
{cat:"Embalagens",code:"DIV77",name:"Filme PVC 28x300m Guarufilm",esp:34.51,prom:29.2},
{cat:"Embalagens",code:"SAC36",name:"Lixo 200L Forte Transp 100und Plast L.P.",esp:131.27,prom:111.07},
{cat:"Embalagens",code:"MAT202",name:"Papel Manteiga 7,5mx30cm",esp:7.8,prom:6.6},
{cat:"Embalagens",code:"SAC33",name:"Saco Gelo 50x70x0,15 PCT 05kg",esp:190.12,prom:160.87},
{cat:"Embalagens",code:"SAC09",name:"Saco Amostra 15x35 250und",esp:52.65,prom:44.55},
{cat:"Embalagens",code:"SAC22",name:"Saco Plast 15x25 1.000und Kromasa",esp:34.47,prom:29.17},
{cat:"Embalagens",code:"SAC23",name:"Saco Plast 18x25 Kromasa PCT",esp:36.32,prom:30.73},
{cat:"Embalagens",code:"SAC08",name:"Saco Plast 60x90 Baixa PCT Kromasa",esp:92.66,prom:78.4},
{cat:"Embalagens",code:"SAC18",name:"Saco Plast Talher 08x25 1000und",esp:15.79,prom:13.36},
{cat:"Embalagens",code:"SAC51",name:"Sacos Plásticos 50x70 Kromasa",esp:59.08,prom:49.99},
{cat:"Embalagens",code:"SAC27",name:"Sacola Plast 40x50 1000und",esp:64.35,prom:54.45},
{cat:"Embalagens",code:"SAC28",name:"Sacola Plast 50x60 1000und",esp:136.5,prom:115.5},
{cat:"Dispensers Santher",code:"DPA50",name:"Disp Forro Sanit Eleg Bco Comodato",esp:39,prom:33},
{cat:"Dispensers Santher",code:"DHE10",name:"Disp/Eleg Hig Bco/Bco DHE10",esp:195,prom:165},
{cat:"Dispensers Santher",code:"DRE10",name:"Disp/Eleg Hig Rolão Bco Visor Trans",esp:195,prom:165},
{cat:"Dispensers Santher",code:"DSF10",name:"Disp/Eleg Sabonete Foam Bco Visor Trans",esp:195,prom:165},
{cat:"Dispensers Santher",code:"DTE10",name:"Disp/Eleg Toa Bco Visor Transluc",esp:195,prom:165},
{cat:"Dispensers Santher",code:"DAD10",name:"Dispens Toalha Bobina Auto Corte Titanium",esp:195,prom:165},
{cat:"Dispensers Santher",code:"RDQA20",name:"Dispenser Bobina Auto Corte Quartz Bra-Pto",esp:464.52,prom:393.06},
{cat:"Dispensers Santher",code:"DQH20",name:"Dispenser Higiênico Interfolhado Quartz",esp:98.59,prom:83.42},
{cat:"Dispensers Santher",code:"DQR20",name:"Dispenser Higiênico Rolão Quartz Bra-Pto",esp:156,prom:132},
{cat:"Dispensers Santher",code:"DQS20",name:"Dispenser Saboneteira 800ml Quartz",esp:104.14,prom:88.12},
{cat:"Dispensers Santher",code:"DBB10",name:"Dispenser Toalha Bobina Elegance Branco",esp:195,prom:165},
{cat:"Dispensers Santher",code:"RDQT20",name:"Dispenser Toalha Interfolha Quartz Bra-Pto",esp:141.82,prom:120},
{cat:"Dispensers Santher",code:"DTB-10",name:"Toalheiro Cristal Toa Bobina 20cm",esp:234,prom:198},
{cat:"Talheres",code:"DIV57",name:"Colher Forte Branca 10x50und Strawplast",esp:87.75,prom:74.25},
{cat:"Talheres",code:"STRAW32",name:"Colher Refeição Branca 20x50und",esp:87.75,prom:74.25},
{cat:"Talheres",code:"DIV34",name:"Colher Sobremesa Transp 20x50und",esp:59.67,prom:50.49},
{cat:"Talheres",code:"DIV01",name:"Faca Forte Branca 10x50und Strawplast",esp:87.75,prom:74.25},
{cat:"Talheres",code:"STRA58",name:"Faca Refeição 20x50und Strawplast",esp:87.75,prom:74.25},
{cat:"Talheres",code:"DIV29",name:"Faca Refeição Granel 1.000und",esp:76.16,prom:64.44},
{cat:"Talheres",code:"DIV74",name:"Garfo Forte Branco 10x50und Straw",esp:87.75,prom:74.25},
{cat:"Talheres",code:"STRA31",name:"Garfo Refeição 20x50und Strawplast",esp:87.75,prom:74.25},
{cat:"Talheres",code:"DIV30",name:"Garfo Refeição Granel 1.000und",esp:76.16,prom:64.44},
{cat:"Talheres",code:"DIV56",name:"Garfo Sobremesa Transp 1.000und",esp:59.67,prom:50.49},
{cat:"Talheres",code:"DIV37",name:"Mexedor de Café 500und Strawplast",esp:11.7,prom:9.9},
{cat:"Talheres",code:"COP10",name:"Prato 15 Sobremesa Raso Forfest 50x10und",esp:58.5,prom:49.5},
{cat:"Talheres",code:"COP50",name:"Prato 21 Forfest 50x10und",esp:126.75,prom:107.25},
{cat:"Talheres",code:"COT18",name:"Prato Papelão Num 4 c/ 100und",esp:29.25,prom:24.75},
{cat:"TopBel",code:"TOP210",name:"Sabonete Antis Triclosan Bomb 5L",esp:42.9,prom:36.3},
{cat:"TopBel",code:"TOP101",name:"Sabonete Erva Doce Perolado Bomb 5L",esp:17.9,prom:16.17},
{cat:"TopBel",code:"TOP05",name:"Sabonete Erva-Doce BAG 800ml Top Bel",esp:8.58,prom:7.26},
{cat:"TopBel",code:"TOP04",name:"Sabonete Triclosan BAG 800ml Top Bel",esp:12.87,prom:10.89},
{cat:"Vassouras",code:"BET38",name:"Balde Espremedor Noviça-Bettanin 09L",esp:39,prom:33},
{cat:"Vassouras",code:"VAS11",name:"Balde Plástico 08L",esp:11.5,prom:9.73},
{cat:"Vassouras",code:"VAS24",name:"Balde Plástico 15L",esp:19.3,prom:16.33},
{cat:"Vassouras",code:"VAS12",name:"Balde Plástico 20L",esp:36.85,prom:31.18},
{cat:"Vassouras",code:"VAS49",name:"Cabo Alumínio Rosca 1,40m Goedert",esp:33.15,prom:28.05},
{cat:"Vassouras",code:"BET41",name:"Cabo Revestido Rosca Bettanin 9015",esp:9.75,prom:8.25},
{cat:"Vassouras",code:"VAS06",name:"Desentupidor de Pia",esp:6.63,prom:5.61},
{cat:"Vassouras",code:"VAS07",name:"Desentupidor de Vaso",esp:13.06,prom:11.05},
{cat:"Vassouras",code:"BET42",name:"Escova de Canto 9139 Bettanin",esp:11.7,prom:9.9},
{cat:"Vassouras",code:"VAS33",name:"Escova Plast Oval p/Roupa",esp:6.82,prom:5.77},
{cat:"Vassouras",code:"COT12",name:"Escova Vaso c/ Suporte Sanit Plus",esp:9.75,prom:8.25},
{cat:"Vassouras",code:"VAS08",name:"Espanador de Pena 30cm",esp:41.53,prom:35.14},
{cat:"Vassouras",code:"VAS37",name:"Espanador de Sisal",esp:11.5,prom:9.73},
{cat:"Vassouras",code:"BET64",name:"Pá Coletora Plástica 9260 Bettanin",esp:58.5,prom:49.5},
{cat:"Vassouras",code:"VAS39",name:"Pá de Lixo Galvanizada Cabo Longo 60cm",esp:11.31,prom:9.57},
{cat:"Vassouras",code:"VAS09",name:"Pá de Lixo Galvanizada 30cm",esp:6.82,prom:5.77},
{cat:"Vassouras",code:"VAS10",name:"Pá de Lixo Plástica",esp:7.41,prom:6.27},
{cat:"Vassouras",code:"BET02",name:"Pá Jeitosa 9253C Bettanin",esp:27.3,prom:23.1},
{cat:"Vassouras",code:"VAS21",name:"Rodo 1mt",esp:34.51,prom:29.2},
{cat:"Vassouras",code:"VAS05",name:"Rodo 40cm",esp:12.67,prom:10.72},
{cat:"Vassouras",code:"VAS26",name:"Rodo 60cm",esp:15.01,prom:12.7},
{cat:"Vassouras",code:"BET45",name:"Rodo Plástico Vai-Vem 40cm Bettanin",esp:31.2,prom:26.4},
{cat:"Vassouras",code:"BET43",name:"Rodo Pusch 45cm 9054C Bettanin",esp:40.95,prom:34.65},
{cat:"Vassouras",code:"DIV79",name:"Suporte Plast Mop Úmido Nobre",esp:19.03,prom:16.1},
{cat:"Vassouras",code:"VAS28",name:"Vasculho de Sisal",esp:31.2,prom:26.4},
{cat:"Vassouras",code:"VAS16",name:"Vassoura Chapa Rossi",esp:48.9,prom:44.55},
{cat:"Vassouras",code:"VAS31",name:"Vassoura Gary Rossi",esp:86.9,prom:79.2},
{cat:"Vassouras",code:"BET32",name:"Vassoura Casa&Rua 9001-C Bettanin",esp:33.15,prom:28.05},
{cat:"Vassouras",code:"VAS01",name:"Vassoura Chapa 0 Branca",esp:19.98,prom:16.91},
{cat:"Vassouras",code:"VAS27",name:"Vassoura Chapa 2 Azul",esp:23.4,prom:19.8},
{cat:"Vassouras",code:"VAS48",name:"Vassoura Chapa 3 Especial Amarela",esp:27.3,prom:23.1},
{cat:"Vassouras",code:"VAS02",name:"Vassoura Gary 31 Furo Facão",esp:28.56,prom:24.17},
{cat:"Vassouras",code:"BET34",name:"Vassoura Novica 9672C Bettanin",esp:25.35,prom:21.45},
{cat:"Vassouras",code:"VAS04",name:"Vassoura Pelo 40cm",esp:22.52,prom:19.05},
{cat:"Vassouras",code:"VAS35",name:"Vassoura Pelo 60cm",esp:31.2,prom:26.4},
{cat:"Vassouras",code:"BET30",name:"Vassoura Pelo 9003C Varre-1000 Bettanin",esp:31.6,prom:26.74},
{cat:"Vassouras",code:"VAS03",name:"Vassoura Tina Piaçava",esp:7.41,prom:6.27},
{cat:"Vassouras",code:"BET40",name:"Vassourita Bettanin Ref.9141",esp:13.65,prom:11.55}
];

let priceTable = 'esp'; // 'esp' | 'prom' | 'comod'
let activeCat = 'Todos';
let cart = {}; // code -> qty

const CATS = ['Todos',...[...new Set(PRODUCTS.map(p=>p.cat))]];
const fmt = v => v.toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
const TABLE_NAMES = {esp:'ESPECIAL',prom:'PROMOCIONAL',comod:'COMODATO 2026'};


function navTo(section) {
  showSection(section);
  const breadcrumbMap = {
    'produtos': 'Orçamento',
    'catalogo': 'Catálogo Santher', 
    'calculadora': 'Calculadora de Consumo',
    'concorrentes': 'Análise de Concorrentes',
    'crm': 'Funil de Vendas',
    'agenda': 'Agendamentos',
    'universidade': 'Universidade Santher',
    'apresentacao': 'Quem Somos'
  };
  const bc = document.getElementById('breadcrumb-text');
  if (bc && breadcrumbMap[section]) bc.textContent = breadcrumbMap[section];
  document.querySelectorAll('.sidebar .nav-item').forEach(function(n) {
    n.classList.remove('active');
  });
  const active = document.querySelector('.sidebar .nav-item[data-section="' + section + '"]');
  if (active) active.classList.add('active');
  if (window.innerWidth <= 768) closeSidebar();
}
function showSection(section){
 // Scroll para o topo da página
 window.scrollTo({top: 0, behavior: 'smooth'});
 
 const secProd = document.getElementById('secProdutos');
 const secUni = document.getElementById('secUniversidade');
 const secAgd = document.getElementById('secAgenda');
 const secCalc = document.getElementById('secCalculadora');
 const secCatalogo = document.getElementById('secCatalogo');
 const secConcorrentes = document.getElementById('secConcorrentes');
 const secApresentacao = document.getElementById('secApresentacao');
 const secDiagnostico = document.getElementById('secDiagnostico');
 const btnProd = document.getElementById('btnProdutos');
 const btnUni = document.getElementById('btnUniversidade');
 const btnAgd = document.getElementById('btnAgenda');
 const btnCrm = document.getElementById('btnCrm');
 const btnCalc = document.getElementById('btnCalculadora');
 const btnCatalogo = document.getElementById('btnCatalogo');
 const btnConcorrentes = document.getElementById('btnConcorrentes');
 const btnApresentacao = document.getElementById('btnApresentacao');
 const btnDiagnostico = document.getElementById('btnDiagnostico');
 const btnDashboard = document.getElementById('btnDashboard');
 const secCrm = document.getElementById('secCrm');
 
 // Esconder todas
 secProd.style.display='none';
 secUni.style.display='none';
 secAgd.style.display='none';
 secCrm.style.display='none';
 secCalc.style.display='none';
 secCatalogo.style.display='none';
 secConcorrentes.style.display='none';
 secApresentacao.style.display='none';
 secDiagnostico.style.display='none';
 
 // Reset botões
 btnProd.className='btn';
 btnProd.style.background='var(--pri)';
 btnProd.style.color='#fff';
 btnUni.className='btn';
 btnUni.style.background='#f59e0b';
 btnUni.style.color='#fff';
 btnAgd.className='btn';
 btnAgd.style.background='#8b5cf6';
 btnAgd.style.color='#fff';
 btnCrm.className='btn';
 btnCrm.style.background='#ec4899';
 btnCrm.style.color='#fff';
 btnCalc.className='btn';
 btnCalc.style.background='#10b981';
 btnCalc.style.color='#fff';
 btnCatalogo.className='btn';
 btnCatalogo.style.background='#ef4444';
 btnCatalogo.style.color='#fff';
 btnConcorrentes.className='btn';
 btnConcorrentes.style.background='#dc2626';
 btnConcorrentes.style.color='#fff';
 btnApresentacao.className='btn';
 btnApresentacao.style.background='#0891b2';
 btnApresentacao.style.color='#fff';
 btnDiagnostico.className='btn';
 btnDiagnostico.style.background='#a855f7';
 btnDiagnostico.style.color='#fff';
 if(btnDashboard){btnDashboard.className='btn';btnDashboard.style.background='#7c3aed';btnDashboard.style.color='#fff';}
 
 // Mostrar seção ativa
 if(section==='produtos'){
  secProd.style.display='block';
  btnProd.className='btn btn-pri';
 }else if(section==='universidade'){
  secUni.style.display='block';
  btnUni.style.background='#f59e0b';
 }else if(section==='agenda'){
  secAgd.style.display='block';
  btnAgd.style.background='#8b5cf6';
  renderAgendamentos();
  atualizarFiltroVendedores();
 }else if(section==='crm'){
  secCrm.style.display='block';
  btnCrm.style.background='#ec4899';
  verificarAutenticacao(); // Verificar login ao abrir CRM
 }else if(section==='calculadora'){
  secCalc.style.display='block';
  btnCalc.style.background='#10b981';
  calcularConsumo();
 }else if(section==='catalogo'){
  secCatalogo.style.display='block';
  btnCatalogo.style.background='#ef4444';
 }else if(section==='concorrentes'){
  secConcorrentes.style.display='block';
  btnConcorrentes.style.background='#dc2626';
 }else if(section==='apresentacao'){
  secApresentacao.style.display='block';
  btnApresentacao.style.background='#0891b2';
 }else if(section==='diagnostico'){
  secDiagnostico.style.display='block';
  btnDiagnostico.style.background='#a855f7';
 }
}

function init(){
 showSection('produtos'); // inicia na seção produtos
 // build cat tabs
 const tabs = document.getElementById('catTabs');
 CATS.forEach(c=>{
  const d = document.createElement('div');
  d.className = 'cat-tab'+(c==='Todos'?' active':'');
  d.textContent = c;
  d.onclick = ()=>{activeCat=c;document.querySelectorAll('.cat-tab').forEach(t=>t.classList.remove('active'));d.classList.add('active');renderProducts()};
  tabs.appendChild(d);
 });
 renderProducts();
 renderCart();
 // CNPJ mask
 document.getElementById('cli-cnpj').addEventListener('input',function(e){
  let v=this.value.replace(/\D/g,'').slice(0,14);
  if(v.length>12)v=v.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d+)/,'$1.$2.$3/$4-$5');
  else if(v.length>8)v=v.replace(/^(\d{2})(\d{3})(\d{3})(\d+)/,'$1.$2.$3/$4');
  else if(v.length>5)v=v.replace(/^(\d{2})(\d{3})(\d+)/,'$1.$2.$3');
  else if(v.length>2)v=v.replace(/^(\d{2})(\d+)/,'$1.$2');
  this.value=v;
 });
}

function getPrice(p){
 if(priceTable==='comod' && p.comod!=null) return p.comod;
 if(priceTable==='prom') return p.prom;
 return p.esp;
}
function isComodItem(p){ return p.comod!=null; }

function renderProducts(){
 const search = document.getElementById('searchInput').value.toLowerCase();
 const body = document.getElementById('prodBody');
 const parts = [];
 let lastCat = '';
 PRODUCTS.forEach(p=>{
  if(activeCat!=='Todos' && p.cat!==activeCat) return;
  if(search && !p.name.toLowerCase().includes(search) && !p.code.toLowerCase().includes(search)) return;
  if(priceTable==='comod' && !isComodItem(p)) return;
  if(p.cat!==lastCat){
   parts.push(`<tr><td colspan="5" style="background:var(--pri);color:var(--acc);font-weight:700;padding:8px;font-family:Barlow">${p.cat}</td></tr>`);
   lastCat=p.cat;
  }
  const qty = cart[p.code]||0;
  const price = getPrice(p);
  const sub = qty*price;
  parts.push(`<tr class="${qty>0?'highlight':''}" data-code="${p.code}">
   <td class="code">${p.code}</td>
   <td>${p.name}</td>
   <td class="price">${fmt(price)}</td>
   <td><input type="number" class="qty-input" min="0" value="${qty}" onchange="setQty('${p.code}',this.value)" onfocus="this.select()"></td>
   <td class="subtotal" id="sub_${p.code}">${qty>0?fmt(sub):'-'}</td>
  </tr>`);
 });
 body.innerHTML = parts.length ? parts.join('') : '<tr><td colspan="5" style="text-align:center;padding:20px;color:var(--muted)">Nenhum produto encontrado</td></tr>';
}

// Debounce para busca — evita rerenderizar a cada tecla
let _searchTimer = null;
function filterProducts(){
 clearTimeout(_searchTimer);
 _searchTimer = setTimeout(renderProducts, 180);
}

function setQty(code,val){
 const q = Math.max(0,parseInt(val)||0);
 if(q>0) cart[code]=q; else delete cart[code];
 // Atualiza só a linha afetada (muito mais rápido que rerenderizar tudo)
 const row = document.querySelector(`tr[data-code="${code}"]`);
 if(row){
  const p = PRODUCTS.find(x=>x.code===code);
  const price = getPrice(p);
  const sub = q*price;
  row.className = q>0?'highlight':'';
  const subCell = document.getElementById('sub_'+code);
  if(subCell) subCell.textContent = q>0?fmt(sub):'-';
 }
 renderCart();
}

function removeFromCart(code){
 delete cart[code];
 renderProducts();
 renderCart();
}

function getCartItems(){
 return Object.entries(cart).map(([code,qty])=>{
  const p = PRODUCTS.find(x=>x.code===code);
  return {code,qty,name:p.name,price:getPrice(p),sub:qty*getPrice(p),cat:p.cat};
 });
}

function renderCart(){
 const items = getCartItems();
 const subtotal = items.reduce((s,i)=>s+i.sub,0);
 const discPct = parseFloat(document.getElementById('discInput')?.value)||0;
 const discVal = subtotal*(discPct/100);
 const total = subtotal-discVal;
 const badge = document.getElementById('cartBadge');
 if(badge) badge.textContent = items.length;

 const html = `
  <h3>🛒 Carrinho (${items.length} ${items.length===1?'item':'itens'})</h3>
  ${items.length===0?'<div class="empty-cart">Adicione produtos alterando a quantidade</div>':''}
  ${items.map(i=>`<div class="cart-item">
   <div class="ci-name"><strong>${i.code}</strong><br><small>${i.name}</small></div>
   <div class="ci-qty">${i.qty}x</div>
   <div class="ci-val">${fmt(i.sub)}</div>
   <div class="ci-rm" onclick="removeFromCart('${i.code}')">✕</div>
  </div>`).join('')}
  <div class="totals">
   <div class="row"><span>Subtotal</span><span>${fmt(subtotal)}</span></div>
   <div class="row discount-row"><span>Desconto</span><input type="number" id="discInput" min="0" max="100" value="${discPct}" onchange="renderCart()" style="width:60px" onfocus="this.select()"><span>%</span><span>-${fmt(discVal)}</span></div>
   <div class="row total-final"><span>TOTAL</span><span>${fmt(total)}</span></div>
  </div>`;
 
 document.getElementById('cartDesktop').innerHTML = html;
 document.getElementById('cartMobile').innerHTML = html;
}

function setTable(t){
 priceTable=t;
 document.querySelectorAll('.ps-btn').forEach(b=>{
  b.classList.remove('active','active-prom','active-comod');
 });
 const btns=document.querySelectorAll('.ps-btn');
 const idx={esp:0,prom:1,comod:2}[t];
 btns[idx].classList.add('active');
 if(t==='prom') btns[idx].classList.add('active-prom');
 if(t==='comod') btns[idx].classList.add('active-comod');
 renderProducts();
 renderCart();
}

function openCartModal(){ document.getElementById('cartModal').classList.add('open'); }
function closeCartModal(){ document.getElementById('cartModal').classList.remove('open'); }

function gerarPDF(){
 const razao = document.getElementById('cli-razao').value.trim();
 const items = getCartItems();
 if(!razao){alert('Preencha a Razão Social do cliente.');return;}
 if(items.length===0){alert('Adicione pelo menos 1 item ao carrinho.');return;}

 const {jsPDF} = window.jspdf;
 const doc = new jsPDF('p','mm','a4');
 const W=210, M=15;
 let y=15;

 // Header
 doc.setFillColor(26,58,92);
 doc.rect(0,0,W,32,'F');
 
 // Logo (texto)
 doc.setTextColor(255,255,255);
 doc.setFont('helvetica','bold');
 doc.setFontSize(18);
 doc.text('JORI PAPEL',M,14);
 
 doc.setTextColor(255,255,255);
 doc.setFontSize(9);
 doc.setFont('helvetica','normal');
 doc.text('(21) 99189-3818 | joriartefatos@gmail.com',M,28);
 
 // Accent line
 doc.setFillColor(245,166,35);
 doc.rect(0,32,W,2,'F');
 y=40;

 // Orcamento title
 doc.setTextColor(26,58,92);
 doc.setFontSize(14);
 doc.setFont('helvetica','bold');
 doc.text('ORÇAMENTO',M,y);
 const hoje = new Date().toLocaleDateString('pt-BR');
 doc.setFontSize(9);
 doc.setFont('helvetica','normal');
 doc.text('Data: '+hoje,W-M,y,{align:'right'});
 doc.text('Tabela: '+TABLE_NAMES[priceTable],W-M,y+5,{align:'right'});
 y+=10;

 // Vendedor
 const vendedor = document.getElementById('vendedor').value.trim();
 if(vendedor){doc.setFontSize(9);doc.text('Vendedor: '+vendedor,M,y);y+=5;}

 // Cliente
 doc.setFillColor(240,244,248);
 doc.rect(M,y,W-2*M,28,'F');
 doc.setTextColor(26,58,92);
 doc.setFontSize(10);
 doc.setFont('helvetica','bold');
 doc.text('DADOS DO CLIENTE',M+3,y+5);
 doc.setFont('helvetica','normal');
 doc.setFontSize(8);
 doc.setTextColor(30,30,30);
 const cliFields = [
  'Razão Social: '+razao,
  'CNPJ: '+(document.getElementById('cli-cnpj').value||'-'),
  'Endereço: '+(document.getElementById('cli-end').value||'-')+' | '+(document.getElementById('cli-cidade').value||'-'),
  'Tel: '+(document.getElementById('cli-tel').value||'-')+' | Email: '+(document.getElementById('cli-email').value||'-')
 ];
 cliFields.forEach((t,i)=>doc.text(t,M+3,y+11+i*4.5));
 y+=34;

 // Table
 const tableData = items.map(i=>[i.code,i.name,String(i.qty),fmt(i.price),fmt(i.sub)]);
 doc.autoTable({
  startY:y,
  head:[['Código','Produto','Qtd','Preço Unit.','Subtotal']],
  body:tableData,
  margin:{left:M,right:M},
  styles:{fontSize:8,cellPadding:2,font:'helvetica'},
  headStyles:{fillColor:[26,58,92],textColor:255,fontStyle:'bold',fontSize:8},
  alternateRowStyles:{fillColor:[245,247,250]},
  columnStyles:{0:{cellWidth:22},2:{cellWidth:12,halign:'center'},3:{cellWidth:28,halign:'right'},4:{cellWidth:28,halign:'right'}},
 });
 y = doc.lastAutoTable.finalY+5;

 // Totals
 const subtotal = items.reduce((s,i)=>s+i.sub,0);
 const discPct = parseFloat(document.getElementById('discInput')?.value)||0;
 const discVal = subtotal*(discPct/100);
 const total = subtotal-discVal;

 const tx = W-M;
 doc.setFontSize(9);
 doc.setTextColor(30,30,30);
 doc.text('Subtotal: '+fmt(subtotal),tx,y,{align:'right'});y+=5;
 if(discPct>0){doc.text('Desconto ('+discPct.toFixed(1)+'%): -'+fmt(discVal),tx,y,{align:'right'});y+=5;}
 doc.setFillColor(26,58,92);doc.rect(tx-60,y-3,62,8,'F');
 doc.setTextColor(255);doc.setFont('helvetica','bold');doc.setFontSize(11);
 doc.text('TOTAL: '+fmt(total),tx-1,y+2,{align:'right'});
 y+=14;

 // Obs
 const obs = document.getElementById('obs').value.trim();
 if(obs){
  doc.setTextColor(26,58,92);doc.setFont('helvetica','bold');doc.setFontSize(9);
  doc.text('Observações:',M,y);y+=4;
  doc.setFont('helvetica','normal');doc.setTextColor(60,60,60);doc.setFontSize(8);
  const lines = doc.splitTextToSize(obs,W-2*M);
  doc.text(lines,M,y);y+=lines.length*4+5;
 }

 // Footer
 const fy = 285;
 
 // Badge Comodato (sem imagem)
 doc.setFillColor(26,58,92);
 doc.roundedRect(W-60, fy-12, 45, 8, 1, 1, 'F');
 doc.setFontSize(8);
 doc.setTextColor(255,255,255);
 doc.setFont('helvetica','bold');
 doc.text('COMODATO GRÁTIS', W-37.5, fy-7, {align:'center'});
 
 doc.setFillColor(245,166,35);doc.rect(0,fy-2,W,1,'F');
 doc.setFontSize(7);doc.setTextColor(100);doc.setFont('helvetica','normal');
 doc.text('Jori Artefatos de Papel Ltda | (21) 99189-3818 | joriartefatos@gmail.com',W/2,fy+3,{align:'center'});

 // Salvar dados para compartilhamento
 lastClientName = razao;
 lastClientPhone = document.getElementById('cli-tel').value.trim();
 
 doc.save('orcamento-jori-'+razao.replace(/\s+/g,'-').substring(0,20)+'.pdf');
 
 // Abrir modal de compartilhamento
 setTimeout(() => {
  document.getElementById('shareModalOverlay').classList.add('open');
 }, 300);
}

// ========== REMOVER TUDO ABAIXO TEMPORARIAMENTE ==========
/*
function gerarPDF_Minimalista(){
 const razao = document.getElementById('cli-razao').value.trim();
 const items = getCartItems();
 if(!razao){alert('Preencha a Razão Social do cliente.');return;}
 if(items.length===0){alert('Adicione pelo menos 1 item ao carrinho.');return;}

 const {jsPDF} = window.jspdf;
 const doc = new jsPDF('p','mm','a4');
 const W=210, M=20;
 let y=20;

 // Header minimalista
 doc.setTextColor(30,30,30);
 doc.setFont('helvetica','bold');
 doc.setFontSize(24);
 doc.text('JORI PAPEL',M,y);
 doc.setFontSize(9);
 doc.setFont('helvetica','normal');
 doc.setTextColor(120,120,120);
 doc.text('Distribuidor Oficial Santher Professional',M,y+6);
 
 // Data no canto
 const hoje = new Date().toLocaleDateString('pt-BR');
 doc.setFontSize(8);
 doc.setTextColor(150,150,150);
 doc.text(hoje,W-M,y,{align:'right'});
 doc.text(TABLE_NAMES[priceTable],W-M,y+5,{align:'right'});
 
 // Linha sutil
 doc.setDrawColor(220,220,220);
 doc.setLineWidth(0.3);
 doc.line(M,y+10,W-M,y+10);
 y+=18;

 // Orçamento
 doc.setTextColor(30,30,30);
 doc.setFontSize(11);
 doc.setFont('helvetica','bold');
 doc.text('Orçamento',M,y);
 y+=8;

 // Cliente - estilo clean
 doc.setFontSize(8);
 doc.setFont('helvetica','bold');
 doc.setTextColor(100,100,100);
 doc.text('CLIENTE',M,y);
 y+=5;
 
 doc.setFont('helvetica','normal');
 doc.setTextColor(50,50,50);
 doc.setFontSize(9);
 doc.text(razao,M,y);y+=5;
 
 const cnpj = document.getElementById('cli-cnpj').value.trim();
 const end = document.getElementById('cli-end').value.trim();
 const cidade = document.getElementById('cli-cidade').value.trim();
 const tel = document.getElementById('cli-tel').value.trim();
 const email = document.getElementById('cli-email').value.trim();
 
 doc.setFontSize(8);
 doc.setTextColor(120,120,120);
 if(cnpj) {doc.text('CNPJ: '+cnpj,M,y);y+=4;}
 if(end||cidade) {doc.text((end||'')+' '+(cidade?'| '+cidade:''),M,y);y+=4;}
 if(tel||email) {doc.text((tel?tel+' | ':'')+email,M,y);y+=4;}
 
 y+=6;
 doc.setDrawColor(240,240,240);
 doc.line(M,y,W-M,y);
 y+=8;

 // Vendedor
 const vendedor = document.getElementById('vendedor').value.trim();
 if(vendedor){
  doc.setFontSize(8);
  doc.setTextColor(120,120,120);
  doc.text('Atendimento: '+vendedor,M,y);
  y+=6;
 }

 // Table - estilo minimal
 const tableData = items.map(i=>[i.code,i.name,String(i.qty),fmt(i.price),fmt(i.sub)]);
 doc.autoTable({
  startY:y,
  head:[['Cód.','Produto','Qtd','Preço','Total']],
  body:tableData,
  margin:{left:M,right:M},
  styles:{fontSize:8.5,cellPadding:3,font:'helvetica',textColor:[50,50,50]},
  headStyles:{fillColor:[250,250,250],textColor:[80,80,80],fontStyle:'bold',fontSize:8},
  alternateRowStyles:{fillColor:[252,252,252]},
  columnStyles:{
   0:{cellWidth:20,textColor:[120,120,120],fontSize:7.5},
   2:{cellWidth:14,halign:'center'},
   3:{cellWidth:26,halign:'right'},
   4:{cellWidth:26,halign:'right',fontStyle:'bold'}
  },
  theme:'plain',
  lineColor:[235,235,235],
  lineWidth:0.1,
 });
 y = doc.lastAutoTable.finalY+10;

 // Totals - clean
 const subtotal = items.reduce((s,i)=>s+i.sub,0);
 const discPct = parseFloat(document.getElementById('discInput')?.value)||0;
 const discVal = subtotal*(discPct/100);
 const total = subtotal-discVal;

 const tx = W-M;
 doc.setFontSize(9);
 doc.setTextColor(100,100,100);
 doc.text('Subtotal',tx-35,y,{align:'left'});
 doc.text(fmt(subtotal),tx,y,{align:'right'});
 y+=5;
 
 if(discPct>0){
  doc.text('Desconto ('+discPct.toFixed(1)+'%)',tx-35,y,{align:'left'});
  doc.text('-'+fmt(discVal),tx,y,{align:'right'});
  y+=5;
 }
 
 y+=3;
 doc.setDrawColor(220,220,220);
 doc.line(tx-60,y,tx,y);
 y+=6;
 
 doc.setFontSize(14);
 doc.setTextColor(30,30,30);
 doc.setFont('helvetica','bold');
 doc.text('Total',tx-35,y,{align:'left'});
 doc.text(fmt(total),tx,y,{align:'right'});
 y+=10;

 // Obs
 const obs = document.getElementById('obs').value.trim();
 if(obs){
  doc.setDrawColor(240,240,240);
  doc.line(M,y,W-M,y);
  y+=5;
  doc.setTextColor(100,100,100);
  doc.setFont('helvetica','bold');
  doc.setFontSize(8);
  doc.text('OBSERVAÇÕES',M,y);
  y+=4;
  doc.setFont('helvetica','normal');
  doc.setTextColor(80,80,80);
  doc.setFontSize(8);
  const lines = doc.splitTextToSize(obs,W-2*M);
  doc.text(lines,M,y);
  y+=lines.length*4+5;
 }

 // Footer minimal
 const fy = 285;
 doc.setFontSize(7);
 doc.setTextColor(180,180,180);
 doc.setFont('helvetica','normal');
 doc.text('Jori Artefatos de Papel Ltda',W/2,fy,{align:'center'});
 doc.text('(21) 99189-3818  •  joriartefatos@gmail.com',W/2,fy+4,{align:'center'});

 doc.save('orcamento-jori-'+razao.replace(/\s+/g,'-').substring(0,20)+'.pdf');
}

// ========== LAYOUT 3: PREMIUM ==========
function gerarPDF_Premium(){
 const razao = document.getElementById('cli-razao').value.trim();
 const items = getCartItems();
 if(!razao){alert('Preencha a Razão Social do cliente.');return;}
 if(items.length===0){alert('Adicione pelo menos 1 item ao carrinho.');return;}

 const {jsPDF} = window.jspdf;
 const doc = new jsPDF('p','mm','a4');
 const W=210, M=15;
 let y=12;

 // Header premium com gradiente simulado (faixas)
 for(let i=0;i<35;i++){
  const r = 26 + i*0.3;
  const g = 58 + i*0.9;
  const b = 92 + i*0.3;
  doc.setFillColor(r,g,b);
  doc.rect(0,i*0.9,W,1,'F');
 }
 
 // Accent bar dourado
 doc.setFillColor(245,166,35);
 doc.rect(0,33,W,4,'F');
 
 // Logo/Nome
 doc.setTextColor(255,255,255);
 doc.setFont('helvetica','bold');
 doc.setFontSize(22);
 doc.text('JORI PAPEL',M,16);
 doc.setFontSize(9);
 doc.setFont('helvetica','normal');
 doc.text('Distribuidor Oficial Santher Professional',M,22);
 doc.setFontSize(8);
 doc.text('(21) 99189-3818  |  joriartefatos@gmail.com',M,28);
 
 // Badge "Orçamento"
 doc.setFillColor(255,255,255);
 doc.roundedRect(W-45,12,30,10,2,2,'F');
 doc.setTextColor(26,58,92);
 doc.setFont('helvetica','bold');
 doc.setFontSize(9);
 doc.text('ORÇAMENTO',W-30,18.5,{align:'center'});
 
 y=45;

 // Info bar
 doc.setFillColor(250,250,250);
 doc.rect(M,y,W-2*M,12,'F');
 doc.setDrawColor(245,166,35);
 doc.setLineWidth(0.5);
 doc.line(M,y,M,y+12);
 
 const hoje = new Date().toLocaleDateString('pt-BR');
 doc.setTextColor(80,80,80);
 doc.setFont('helvetica','normal');
 doc.setFontSize(8);
 doc.text('Data: '+hoje,M+3,y+5);
 doc.text('Tabela: '+TABLE_NAMES[priceTable],M+3,y+9);
 
 const vendedor = document.getElementById('vendedor').value.trim();
 if(vendedor){
  doc.text('Vendedor: '+vendedor,W-M-3,y+7,{align:'right'});
 }
 
 y+=18;

 // Cliente - card com borda
 doc.setFillColor(255,255,255);
 doc.setDrawColor(220,220,220);
 doc.setLineWidth(0.3);
 doc.roundedRect(M,y,W-2*M,26,1.5,1.5,'FD');
 
 doc.setFillColor(26,58,92);
 doc.rect(M,y,4,26,'F');
 
 doc.setTextColor(26,58,92);
 doc.setFont('helvetica','bold');
 doc.setFontSize(9);
 doc.text('DADOS DO CLIENTE',M+7,y+5);
 
 doc.setFont('helvetica','normal');
 doc.setTextColor(50,50,50);
 doc.setFontSize(9);
 doc.text(razao,M+7,y+11);
 
 const cnpj = document.getElementById('cli-cnpj').value.trim();
 const end = document.getElementById('cli-end').value.trim();
 const cidade = document.getElementById('cli-cidade').value.trim();
 const tel = document.getElementById('cli-tel').value.trim();
 const email = document.getElementById('cli-email').value.trim();
 
 doc.setFontSize(7.5);
 doc.setTextColor(100,100,100);
 let cy = y+15.5;
 if(cnpj) {doc.text('CNPJ: '+cnpj,M+7,cy);cy+=3.5;}
 if(end||cidade) {doc.text((end||'')+' '+(cidade?'| '+cidade:''),M+7,cy);cy+=3.5;}
 if(tel||email) {doc.text((tel?tel+' | ':'')+email,M+7,cy);}
 
 y+=32;

 // Table premium
 const tableData = items.map(i=>[i.code,i.name,String(i.qty),fmt(i.price),fmt(i.sub)]);
 doc.autoTable({
  startY:y,
  head:[['Código','Produto','Qtd','Preço Unit.','Subtotal']],
  body:tableData,
  margin:{left:M,right:M},
  styles:{fontSize:8.5,cellPadding:3,font:'helvetica'},
  headStyles:{
   fillColor:[26,58,92],
   textColor:255,
   fontStyle:'bold',
   fontSize:8.5,
   lineWidth:0,
  },
  alternateRowStyles:{fillColor:[248,250,252]},
  columnStyles:{
   0:{cellWidth:22,textColor:[100,100,100]},
   2:{cellWidth:14,halign:'center'},
   3:{cellWidth:28,halign:'right'},
   4:{cellWidth:28,halign:'right',fontStyle:'bold',textColor:[26,58,92]}
  },
  rowStyles:{lineWidth:0.1,lineColor:[230,230,230]},
 });
 y = doc.lastAutoTable.finalY+8;

 // Totals premium com card
 const subtotal = items.reduce((s,i)=>s+i.sub,0);
 const discPct = parseFloat(document.getElementById('discInput')?.value)||0;
 const discVal = subtotal*(discPct/100);
 const total = subtotal-discVal;

 doc.setFillColor(248,250,252);
 doc.roundedRect(W-70,y,55,discPct>0?20:15,2,2,'F');
 
 const tx = W-M-3;
 doc.setFontSize(8.5);
 doc.setTextColor(80,80,80);
 doc.text('Subtotal: '+fmt(subtotal),tx,y+5,{align:'right'});
 
 if(discPct>0){
  doc.text('Desconto ('+discPct.toFixed(1)+'%): -'+fmt(discVal),tx,y+10,{align:'right'});
  y+=5;
 }
 
 y+= discPct>0 ? 18 : 13;
 
 // Total destaque com fundo dourado
 doc.setFillColor(245,166,35);
 doc.roundedRect(W-70,y,55,12,2,2,'F');
 doc.setTextColor(255,255,255);
 doc.setFont('helvetica','bold');
 doc.setFontSize(12);
 doc.text('TOTAL: '+fmt(total),tx,y+8,{align:'right'});
 
 y+=18;

 // Obs
 const obs = document.getElementById('obs').value.trim();
 if(obs){
  doc.setFillColor(255,250,240);
  doc.roundedRect(M,y,W-2*M,-1,1.5,1.5,'F');
  doc.setTextColor(26,58,92);
  doc.setFont('helvetica','bold');
  doc.setFontSize(8.5);
  doc.text('💡 Observações',M+3,y+5);
  doc.setFont('helvetica','normal');
  doc.setTextColor(80,80,80);
  doc.setFontSize(8);
  const lines = doc.splitTextToSize(obs,W-2*M-6);
  doc.text(lines,M+3,y+10);
  y+=lines.length*4+15;
 }

 // Footer premium
 const fy = 285;
 doc.setFillColor(26,58,92);
 doc.rect(0,fy-8,W,15,'F');
 doc.setFillColor(245,166,35);
 doc.rect(0,fy-8,W,1.5,'F');
 doc.setFontSize(7.5);
 doc.setTextColor(255,255,255);
 doc.setFont('helvetica','bold');
 doc.text('JORI ARTEFATOS DE PAPEL LTDA',W/2,fy-2,{align:'center'});
 doc.setFont('helvetica','normal');
 doc.setFontSize(7);
 doc.text('(21) 99189-3818  •  joriartefatos@gmail.com  •  Mais de 40 anos no mercado',W/2,fy+2,{align:'center'});

 doc.save('orcamento-jori-'+razao.replace(/\s+/g,'-').substring(0,20)+'.pdf');
}

*/
init();

/* === NEXT BLOCK === */

let lastClientName = '';
let lastClientPhone = '';

function openAiModal(){
 document.getElementById('aiModalOverlay').classList.add('open');
}
function closeAiModal(){
 document.getElementById('aiModalOverlay').classList.remove('open');
}
function openWhatsApp(){
 const msg = encodeURIComponent('Olá! Vim do site de orçamentos e gostaria de tirar algumas dúvidas.');
 window.open('https://wa.me/5521991893818?text='+msg,'_blank');
}
function closeShareModal(){
 document.getElementById('shareModalOverlay').classList.remove('open');
}
function shareWhatsApp(){
 const razao = lastClientName || 'cliente';
 const tel = lastClientPhone.replace(/\D/g,'');
 const msg = encodeURIComponent(`Olá! Segue em anexo o orçamento da Jori Papel para ${razao}. Qualquer dúvida, estou à disposição!`);
 const url = tel.length >= 10 ? `https://wa.me/55${tel}?text=${msg}` : `https://wa.me/?text=${msg}`;
 window.open(url, '_blank');
 closeShareModal();
}

// ============ AGENDA CONSULTOR SANTHER ============
let agendamentos = JSON.parse(localStorage.getItem('agendamentos-santher')||'[]');
let vendedores = JSON.parse(localStorage.getItem('vendedores-santher')||'["Rackel","Débora","Bianca"]');
let agdCancelarId = null;

// Listener para mostrar campo de novo vendedor
document.addEventListener('DOMContentLoaded',()=>{
 const selVend = document.getElementById('agd-vendedor');
 const inputNovo = document.getElementById('agd-vendedor-novo');
 if(selVend){
  selVend.addEventListener('change',()=>{
   inputNovo.style.display = selVend.value==='__novo__' ? 'block' : 'none';
  });
 }
});

function salvarAgendamento(){
 const vendSel = document.getElementById('agd-vendedor').value;
 const vendNovo = document.getElementById('agd-vendedor-novo').value.trim();
 const vendedor = vendSel==='__novo__' ? vendNovo : vendSel;
 const cliente = document.getElementById('agd-cliente').value.trim();
 const data = document.getElementById('agd-data').value;
 const servico = document.getElementById('agd-servico').value;
 const periodo = document.getElementById('agd-periodo').value;
 const obs = document.getElementById('agd-obs').value.trim();
 const alerta = document.getElementById('agd-alerta');
 
 // Validações
 if(!vendedor){
  alerta.textContent='⚠️ Selecione ou crie um vendedor';
  alerta.style.display='block';
  return;
 }
 if(!cliente){
  alerta.textContent='⚠️ Preencha o nome do cliente';
  alerta.style.display='block';
  return;
 }
 if(!data){
  alerta.textContent='⚠️ Selecione a data';
  alerta.style.display='block';
  return;
 }
 if(!servico){
  alerta.textContent='⚠️ Selecione o tipo de serviço';
  alerta.style.display='block';
  return;
 }
 if(!periodo){
  alerta.textContent='⚠️ Selecione o período';
  alerta.style.display='block';
  return;
 }
 
 // Verificar se já existem 2 agendamentos no mesmo dia
 const agdDia = agendamentos.filter(a=>a.data===data && a.status==='ativo');
 if(agdDia.length>=2){
  alerta.textContent='❌ Já existem 2 agendamentos neste dia. Escolha outra data.';
  alerta.style.display='block';
  return;
 }
 
 // Verificar conflito de período
 const conflitoPerio = agdDia.find(a=>a.periodo===periodo);
 if(conflitoPerio){
  alerta.textContent=`❌ Já existe um agendamento para ${periodo} neste dia. Escolha outro período ou data.`;
  alerta.style.display='block';
  return;
 }
 
 // Salvar novo vendedor se necessário
 if(vendSel==='__novo__' && vendNovo && !vendedores.includes(vendNovo)){
  vendedores.push(vendNovo);
  localStorage.setItem('vendedores-santher',JSON.stringify(vendedores));
  atualizarSelectVendedores();
 }
 
 // Criar agendamento
 const agd = {
  id: Date.now(),
  vendedor,
  cliente,
  data,
  servico,
  periodo,
  obs,
  status: 'ativo',
  criadoEm: new Date().toISOString()
 };
 
 agendamentos.push(agd);
 localStorage.setItem('agendamentos-santher',JSON.stringify(agendamentos));
 
 // Limpar formulário
 document.getElementById('agd-vendedor').value='';
 document.getElementById('agd-vendedor-novo').value='';
 document.getElementById('agd-vendedor-novo').style.display='none';
 document.getElementById('agd-cliente').value='';
 document.getElementById('agd-data').value='';
 document.getElementById('agd-servico').value='';
 document.getElementById('agd-periodo').value='';
 document.getElementById('agd-obs').value='';
 alerta.style.display='none';
 
 renderAgendamentos();
 alert(`✅ Agendamento confirmado!\n\nVendedor: ${vendedor}\nCliente: ${cliente}\nData: ${new Date(data+'T12:00').toLocaleDateString('pt-BR')}\nServiço: ${servico}\nPeríodo: ${periodo}`);
}

function renderAgendamentos(){
 const filtroVend = document.getElementById('filtro-vendedor')?.value||'';
 const filtroServ = document.getElementById('filtro-servico')?.value||'';
 const filtroStat = document.getElementById('filtro-status')?.value||'ativo';
 
 let lista = agendamentos.slice().reverse(); // mais recentes primeiro
 
 // Aplicar filtros
 if(filtroVend) lista = lista.filter(a=>a.vendedor===filtroVend);
 if(filtroServ) lista = lista.filter(a=>a.servico===filtroServ);
 if(filtroStat!=='todos'){
  lista = lista.filter(a=>a.status===filtroStat);
 }
 
 const div = document.getElementById('agendamentos-lista');
 if(!div) return;
 
 if(lista.length===0){
  div.innerHTML='<div style="text-align:center;padding:30px;color:var(--muted)">📭 Nenhum agendamento encontrado</div>';
  return;
 }
 
 const html = lista.map(a=>{
  const dtFormat = new Date(a.data+'T12:00').toLocaleDateString('pt-BR',{weekday:'short',day:'2-digit',month:'short'});
  const icoServ = {Instalação:'🔧',Manutenção:'🛠️','Visita Técnica':'👨‍🔧'}[a.servico]||'📋';
  const icoPer = {Manhã:'☀️',Tarde:'🌤️'}[a.periodo]||'⏰';
  const cancelado = a.status==='cancelado';
  const bgColor = cancelado ? '#fee2e2' : '#f0f9ff';
  const borderColor = cancelado ? '#ef4444' : '#3b82f6';
  
  return `<div style="border-left:4px solid ${borderColor};background:${bgColor};padding:12px;margin-bottom:10px;border-radius:6px;${cancelado?'opacity:.7':''}">
   <div style="display:flex;justify-content:space-between;align-items:start;margin-bottom:6px">
    <div style="flex:1">
     <div style="font-size:1rem;font-weight:700;color:var(--pri);margin-bottom:4px">
      ${icoServ} ${a.servico} ${cancelado?'<span style="color:#dc2626;font-size:.85rem">(CANCELADO)</span>':''}
     </div>
     <div style="font-size:.85rem;color:var(--muted)">
      <strong>Cliente:</strong> ${a.cliente}<br>
      <strong>Data:</strong> ${dtFormat} | ${icoPer} ${a.periodo}<br>
      <strong>Agendado por:</strong> ${a.vendedor}
      ${a.obs?`<br><strong>Obs:</strong> ${a.obs}`:''}
     </div>
    </div>
    ${!cancelado?`<button class="btn btn-sm btn-danger" onclick="abrirCancelar(${a.id})" style="margin-left:10px">❌</button>`:''}
   </div>
   ${cancelado && a.motivoCancelamento?`<div style="margin-top:8px;padding:8px;background:#fef3c7;border-radius:4px;font-size:.8rem"><strong>Motivo:</strong> ${a.motivoCancelamento}<br><small style="color:var(--muted)">Cancelado em ${new Date(a.canceladoEm).toLocaleString('pt-BR')}</small></div>`:''}
  </div>`;
 }).join('');
 
 div.innerHTML = html;
}

function atualizarSelectVendedores(){
 const sel = document.getElementById('agd-vendedor');
 if(!sel) return;
 const atual = sel.value;
 sel.innerHTML = '<option value="">Selecione...</option>';
 vendedores.forEach(v=>{
  const opt = document.createElement('option');
  opt.value = v;
  opt.textContent = v;
  sel.appendChild(opt);
 });
 const optNovo = document.createElement('option');
 optNovo.value = '__novo__';
 optNovo.textContent = '➕ Criar novo vendedor...';
 sel.appendChild(optNovo);
 if(atual) sel.value = atual;
}

function atualizarFiltroVendedores(){
 const filtro = document.getElementById('filtro-vendedor');
 if(!filtro) return;
 const atual = filtro.value;
 filtro.innerHTML = '<option value="">Todos</option>';
 vendedores.forEach(v=>{
  const opt = document.createElement('option');
  opt.value = v;
  opt.textContent = v;
  filtro.appendChild(opt);
 });
 if(atual) filtro.value = atual;
}

function abrirCancelar(id){
 agdCancelarId = id;
 document.getElementById('cancel-motivo').value='';
 document.getElementById('cancelModalOverlay').classList.add('open');
}

function closeCancelModal(){
 document.getElementById('cancelModalOverlay').classList.remove('open');
 agdCancelarId = null;
}

function confirmarCancelamento(){
 const motivo = document.getElementById('cancel-motivo').value.trim();
 if(!motivo){
  alert('⚠️ Por favor, informe o motivo do cancelamento.');
  return;
 }
 
 const agd = agendamentos.find(a=>a.id===agdCancelarId);
 if(!agd) return;
 
 agd.status = 'cancelado';
 agd.motivoCancelamento = motivo;
 agd.canceladoEm = new Date().toISOString();
 
 localStorage.setItem('agendamentos-santher',JSON.stringify(agendamentos));
 closeCancelModal();
 renderAgendamentos();
 alert('❌ Agendamento cancelado com sucesso.');
}

// Inicializar selects de vendedores ao carregar
if(document.getElementById('agd-vendedor')){
 atualizarSelectVendedores();
}

// ============ CALCULADORA DE CONSUMO ============
// Catálogo de produtos SANTHER (preços tabela Especial)
const PRODUTOS_TOALHA = {
 interfolhada: [
  {code:'ETI00', nome:'ETI00 - Toalha Eco 6x400 (2.400/cx)', folhas:2400, preco:86.50},
  {code:'ETI21', nome:'ETI21 - Toalha Eco 6x350 (2.100/cx)', folhas:2100, preco:71.90},
  {code:'RTI01', nome:'RTI01 - Toalha Reviva 6x400 (2.400/cx)', folhas:2400, preco:104.90},
  {code:'ITI01', nome:'ITI01 - Interf. FS 10x240 (2.400/cx)', folhas:2400, preco:108.90},
  {code:'ITI02', nome:'ITI02 - Interf. FD 10x240 (2.400/cx)', folhas:2400, preco:132.50},
  {code:'ITI03', nome:'ITI03 - Interf. FT 12x200 (2.400/cx)', folhas:2400, preco:154.50},
  {code:'TSP04', nome:'TSP04 - Interf. FQ 10x120 (1.200/cx)', folhas:1200, preco:179.90}
 ],
 bobina: [
  {code:'ETB20', nome:'ETB20 - Bobina Eco 8x250m (2.000m/cx)', metros:2000, preco:269.00},
  {code:'RTB01', nome:'RTB01 - Bobina Reviva 6x200m (1.200m/cx)', metros:1200, preco:209.90},
  {code:'ITB01', nome:'ITB01 - Bobina Santher 6x200m (1.200m/cx)', metros:1200, preco:288.60}
 ]
};

const PRODUTOS_HIGIENICO = {
 rolao: [
  {code:'EHR50', nome:'EHR50 - Rolão Eco 8x500m (4.000m/cx)', metros:4000, preco:125.50},
  {code:'PHR25', nome:'PHR25 - Rolão FD Personal 8x250m (2.000m/cx)', metros:2000, preco:101.90}
 ],
 interfolhado: [
  {code:'PHI12', nome:'PHI12 - Kai-Kai Personal FD 20x600 (12.000/cx)', folhas:12000, preco:169.90}
 ]
};

function atualizarProdutosToalha(){
 const tipo = document.getElementById('calc-tipo-toalha')?.value || '';
 const selProd = document.getElementById('calc-produto-toalha');
 if(!selProd) return;
 
 selProd.innerHTML = '<option value="">Selecione...</option>';
 if(!tipo) return;
 
 const produtos = PRODUTOS_TOALHA[tipo] || [];
 produtos.forEach(p => {
  const opt = document.createElement('option');
  opt.value = p.code;
  opt.textContent = p.nome;
  selProd.appendChild(opt);
 });
 if(produtos.length > 0) selProd.value = produtos[0].code;
 calcularConsumo();
}

function atualizarProdutosHigienico(){
 const tipo = document.getElementById('calc-tipo-higienico')?.value || '';
 const selProd = document.getElementById('calc-produto-higienico');
 if(!selProd) return;
 
 selProd.innerHTML = '<option value="">Selecione...</option>';
 if(!tipo) return;
 
 const produtos = PRODUTOS_HIGIENICO[tipo] || [];
 produtos.forEach(p => {
  const opt = document.createElement('option');
  opt.value = p.code;
  opt.textContent = p.nome;
  selProd.appendChild(opt);
 });
 if(produtos.length > 0) selProd.value = produtos[0].code;
 calcularConsumo();
}

function abrirExtras(){
 // Atualizar estado visual dos botões
 ['sabonete','alcool','forro','protetor'].forEach(id => {
  const checkbox = document.getElementById('calc-'+id);
  const btn = document.getElementById('extra-'+id);
  if(checkbox && btn){
   if(checkbox.checked) btn.classList.add('active');
   else btn.classList.remove('active');
  }
 });
 document.getElementById('extrasModalOverlay').classList.add('open');
}

function fecharExtras(){
 document.getElementById('extrasModalOverlay').classList.remove('open');
}

function toggleExtra(tipo){
 const checkbox = document.getElementById('calc-'+tipo);
 const btn = document.getElementById('extra-'+tipo);
 if(!checkbox || !btn) return;
 
 checkbox.checked = !checkbox.checked;
 if(checkbox.checked) btn.classList.add('active');
 else btn.classList.remove('active');
 
 calcularConsumo();
}

function calcularConsumo(){
 const colab = parseInt(document.getElementById('calc-colab')?.value) || 0;
 const mulheres = parseInt(document.getElementById('calc-mulheres')?.value) || 50;
 const banheiros = parseInt(document.getElementById('calc-banheiros')?.value) || 1;
 const visitas = parseInt(document.getElementById('calc-visitas')?.value) || 0;
 const horario = parseInt(document.getElementById('calc-horario')?.value) || 12;
 const ambiente = document.getElementById('calc-ambiente')?.value || 'escritorio';
 const tipoToalha = document.getElementById('calc-tipo-toalha')?.value || '';
 const codToalha = document.getElementById('calc-produto-toalha')?.value || '';
 const tipoHig = document.getElementById('calc-tipo-higienico')?.value || '';
 const codHig = document.getElementById('calc-produto-higienico')?.value || '';
 const inclSabonete = document.getElementById('calc-sabonete')?.checked || false;
 const inclAlcool = document.getElementById('calc-alcool')?.checked || false;
 const inclForro = document.getElementById('calc-forro')?.checked || false;
 const inclProtetor = document.getElementById('calc-protetor')?.checked || false;
 
 // Fator de ambiente (multiplicador de uso)
 const fatorAmb = {
  escritorio: 1,
  hotel: 1.5,
  restaurante: 1.3,
  clinica: 1.4,
  academia: 1.2,
  condominio: 0.8,
  shopping: 1.6
 }[ambiente] || 1;
 
 // Fator de horário
 const fatorHorario = horario/12; // normalizado para 12h
 
 // Total de pessoas/dia
 const totalPessoas = (colab + visitas) * fatorAmb * fatorHorario;
 
 // Buscar produtos selecionados
 let prodToalha = null;
 if(tipoToalha && codToalha){
  const listaProd = PRODUTOS_TOALHA[tipoToalha] || [];
  prodToalha = listaProd.find(p => p.code === codToalha);
 }
 
 let prodHig = null;
 if(tipoHig && codHig){
  const listaProd = PRODUTOS_HIGIENICO[tipoHig] || [];
  prodHig = listaProd.find(p => p.code === codHig);
 }
 
 // TOALHA
 let cxToalha = 0, custoToalha = 0;
 if(prodToalha){
  if(tipoToalha === 'interfolhada'){
   // Média: 2 folhas por uso, 4 usos/dia por pessoa
   const folhasToalhaDia = totalPessoas * 4 * 2;
   const folhasToalhaMes = folhasToalhaDia * 30;
   cxToalha = Math.ceil(folhasToalhaMes / prodToalha.folhas);
  }else if(tipoToalha === 'bobina'){
   // Média: 30cm por uso, 4 usos/dia por pessoa
   const metrosToalhaDia = (totalPessoas * 4 * 0.3);
   const metrosToalhaMes = metrosToalhaDia * 30;
   cxToalha = Math.ceil(metrosToalhaMes / prodToalha.metros);
  }
  custoToalha = cxToalha * prodToalha.preco;
 }
 
 // PAPEL HIGIÊNICO
 let cxHig = 0, custoHig = 0;
 if(prodHig){
  // Mulheres usam mais (6x/dia vs 3x/dia homens)
  const percMulher = mulheres/100;
  const usosHigDia = (totalPessoas * percMulher * 6) + (totalPessoas * (1-percMulher) * 3);
  
  if(tipoHig === 'rolao'){
   const metrosHigDia = usosHigDia * 1.5; // 1.5m por uso
   const metrosHigMes = metrosHigDia * 30;
   cxHig = Math.ceil(metrosHigMes / prodHig.metros);
  }else if(tipoHig === 'interfolhado'){
   const folhasHigDia = usosHigDia * 10; // 10 folhas por uso
   const folhasHigMes = folhasHigDia * 30;
   cxHig = Math.ceil(folhasHigMes / prodHig.folhas);
  }
  custoHig = cxHig * prodHig.preco;
 }
 
 // SABONETE ESPUMA
 let cxSabonete = 0, custoSabonete = 0;
 if(inclSabonete){
  // 1 acionamento = 0.8ml, 5 usos/dia/pessoa
  const mlDiaSab = totalPessoas * 5 * 0.8;
  const mlMesSab = mlDiaSab * 30;
  cxSabonete = Math.ceil(mlMesSab / 4800); // 6x800ml = 4800ml/cx
  custoSabonete = cxSabonete * 229.90; // SECQ06
 }
 
 // ÁLCOOL GEL
 let cxAlcool = 0, custoAlcool = 0;
 if(inclAlcool){
  // 1 acionamento = 1ml, 3 usos/dia/pessoa
  const mlDiaAlc = totalPessoas * 3 * 1;
  const mlMesAlc = mlDiaAlc * 30;
  cxAlcool = Math.ceil(mlMesAlc / 4800); // 6x800ml
  custoAlcool = cxAlcool * 189.90;
 }
 
 // FORRO DE VASO
 let cxForro = 0, custoForro = 0;
 if(inclForro){
  // 1 forro por uso, ~3 usos/dia/pessoa
  const forrosDia = totalPessoas * 3;
  const forrosMes = forrosDia * 30;
  cxForro = Math.ceil(forrosMes / 1000); // 1000 unidades/cx (estimativa)
  custoForro = cxForro * 80.00; // Estimativa
 }
 
 // PROTETOR DE ASSENTO
 let cxProtetor = 0, custoProtetor = 0;
 if(inclProtetor){
  // 1 protetor por uso, ~3 usos/dia/pessoa
  const protetoresDia = totalPessoas * 3;
  const protetoresMes = protetoresDia * 30;
  cxProtetor = Math.ceil(protetoresMes / 800); // 800 unidades/cx (estimativa)
  custoProtetor = cxProtetor * 90.00; // Estimativa
 }
 
 // DISPENSERS (Comodato Grátis)
 const dispensers = {
  toalha: banheiros,
  higienico: banheiros * 2, // 2 por banheiro
  sabonete: inclSabonete ? banheiros : 0,
  alcool: inclAlcool ? Math.max(2, Math.ceil(banheiros/2)) : 0,
  forro: inclForro ? banheiros : 0,
  protetor: inclProtetor ? banheiros : 0
 };
 
 const totalCusto = custoToalha + custoHig + custoSabonete + custoAlcool + custoForro + custoProtetor;
 
 // RENDERIZAR RESULTADO
 const div = document.getElementById('calc-resultado');
 if(!div) return;
 
 if(!prodToalha || !prodHig){
  div.innerHTML = '<div style="text-align:center;padding:20px;color:rgba(255,255,255,.7)">⚠️ Selecione os produtos de Toalha e Higiênico para ver o resultado</div>';
  return;
 }
 
 const tipoToalhaLabel = tipoToalha === 'interfolhada' ? 'Papel Toalha Interfolhado' : 'Papel Toalha em Bobina';
 const tipoHigLabel = tipoHig === 'rolao' ? 'Papel Higiênico Rolão' : 'Papel Higiênico Interfolhado';
 
 div.innerHTML = `
  <div class="calc-item">
   <h4>🧻 ${tipoToalhaLabel}</h4>
   <div class="calc-row"><span>Produto:</span><span>${prodToalha.nome}</span></div>
   <div class="calc-row"><span>Consumo mensal:</span><strong>${cxToalha} caixas</strong></div>
   <div class="calc-row"><span>Custo mensal:</span><strong>R$ ${custoToalha.toFixed(2)}</strong></div>
   <div class="calc-row"><span>Dispensers:</span><strong>${dispensers.toalha} unidades (Comodato Grátis)</strong></div>
  </div>
  
  <div class="calc-item">
   <h4>🧻 ${tipoHigLabel}</h4>
   <div class="calc-row"><span>Produto:</span><span>${prodHig.nome}</span></div>
   <div class="calc-row"><span>Consumo mensal:</span><strong>${cxHig} caixas</strong></div>
   <div class="calc-row"><span>Custo mensal:</span><strong>R$ ${custoHig.toFixed(2)}</strong></div>
   <div class="calc-row"><span>Dispensers:</span><strong>${dispensers.higienico} unidades (Comodato Grátis)</strong></div>
  </div>
  
  ${inclSabonete ? `
  <div class="calc-item">
   <h4>🧼 Sabonete</h4>
   <div class="calc-row"><span>Produto:</span><span>SECQ06 - Sabonete Quartz Espuma 6x800ml</span></div>
   <div class="calc-row"><span>Consumo mensal:</span><strong>${cxSabonete} caixas</strong></div>
   <div class="calc-row"><span>Custo mensal:</span><strong>R$ ${custoSabonete.toFixed(2)}</strong></div>
   <div class="calc-row"><span>Dispensers:</span><strong>${dispensers.sabonete} unidades (Comodato Grátis)</strong></div>
  </div>
  ` : ''}
  
  ${inclAlcool ? `
  <div class="calc-item">
   <h4>🧴 Álcool gel</h4>
   <div class="calc-row"><span>Produto:</span><span>Álcool Gel 70% Antisséptico 6x800ml</span></div>
   <div class="calc-row"><span>Consumo mensal:</span><strong>${cxAlcool} caixas</strong></div>
   <div class="calc-row"><span>Custo mensal:</span><strong>R$ ${custoAlcool.toFixed(2)}</strong></div>
   <div class="calc-row"><span>Dispensers:</span><strong>${dispensers.alcool} unidades (Comodato Grátis)</strong></div>
  </div>
  ` : ''}
  
  ${inclForro ? `
  <div class="calc-item">
   <h4>🚽 Forro</h4>
   <div class="calc-row"><span>Produto:</span><span>Forro Protetor Descartável (1.000 un/cx)</span></div>
   <div class="calc-row"><span>Consumo mensal:</span><strong>${cxForro} caixas</strong></div>
   <div class="calc-row"><span>Custo mensal:</span><strong>R$ ${custoForro.toFixed(2)}</strong></div>
   <div class="calc-row"><span>Dispensers:</span><strong>${dispensers.forro} unidades (Comodato Grátis)</strong></div>
  </div>
  ` : ''}
  
  ${inclProtetor ? `
  <div class="calc-item">
   <h4>🩸 Absorvente</h4>
   <div class="calc-row"><span>Produto:</span><span>Absorvente Higiênico Descartável (800 un/cx)</span></div>
   <div class="calc-row"><span>Consumo mensal:</span><strong>${cxProtetor} caixas</strong></div>
   <div class="calc-row"><span>Custo mensal:</span><strong>R$ ${custoProtetor.toFixed(2)}</strong></div>
   <div class="calc-row"><span>Dispensers:</span><strong>${dispensers.protetor} unidades (Comodato Grátis)</strong></div>
  </div>
  ` : ''}
  
  <div class="calc-total">
   💰 CUSTO TOTAL MENSAL: R$ ${totalCusto.toFixed(2)}
   <div style="font-size:.75rem;font-weight:400;margin-top:8px;opacity:.9">
    🎁 Todos os ${dispensers.toalha + dispensers.higienico + dispensers.sabonete + dispensers.alcool + dispensers.forro + dispensers.protetor} dispensers em COMODATO GRÁTIS!
   </div>
  </div>
  
  <div style="margin-top:16px;text-align:center">
   <button class="btn" style="background:#fff;color:var(--pri);font-weight:600" onclick="gerarPDFPlanejamento()">
    📄 Gerar PDF do Planejamento
   </button>
  </div>
 `;
}

function gerarPDFPlanejamento(){
 const colab = parseInt(document.getElementById('calc-colab')?.value) || 0;
 const mulheres = parseInt(document.getElementById('calc-mulheres')?.value) || 50;
 const banheiros = parseInt(document.getElementById('calc-banheiros')?.value) || 1;
 const visitas = parseInt(document.getElementById('calc-visitas')?.value) || 0;
 const horario = parseInt(document.getElementById('calc-horario')?.value) || 12;
 const ambiente = document.getElementById('calc-ambiente')?.value || 'escritorio';
 const tipoToalha = document.getElementById('calc-tipo-toalha')?.value || '';
 const codToalha = document.getElementById('calc-produto-toalha')?.value || '';
 const tipoHig = document.getElementById('calc-tipo-higienico')?.value || '';
 const codHig = document.getElementById('calc-produto-higienico')?.value || '';
 
 if(!codToalha || !codHig){
  alert('Selecione os produtos de Toalha e Higienico antes de gerar o PDF.');
  return;
 }
 
 const {jsPDF} = window.jspdf;
 const doc = new jsPDF();
 
 // Header azul
 doc.setFillColor(26,58,92);
 doc.rect(0,0,210,35,'F');
 doc.setTextColor(255,255,255);
 doc.setFontSize(20);
 doc.setFont('helvetica','bold');
 doc.text('JORI PAPEL',105,15,{align:'center'});
 doc.setFontSize(11);
 doc.setFont('helvetica','normal');
 doc.text('Planejamento de Comodato Santher',105,23,{align:'center'});
 doc.setFontSize(9);
 doc.text(new Date().toLocaleDateString('pt-BR'),105,29,{align:'center'});
 
 let y = 45;
 
 // Perfil do Estabelecimento
 doc.setTextColor(26,58,92);
 doc.setFontSize(12);
 doc.setFont('helvetica','bold');
 doc.text('PERFIL DO ESTABELECIMENTO',20,y);
 y += 8;
 
 doc.autoTable({
  startY: y,
  head: [['Item','Valor']],
  body: [
   ['Colaboradores',colab.toString()],
   ['Percentual Mulheres',mulheres+'%'],
   ['Banheiros',banheiros.toString()],
   ['Visitas por Dia',visitas.toString()],
   ['Horario Funcionamento',horario+'h'],
   ['Tipo de Ambiente',ambiente.charAt(0).toUpperCase()+ambiente.slice(1)]
  ],
  theme: 'grid',
  headStyles: {fillColor: [26,58,92], fontSize: 9, fontStyle: 'bold'},
  bodyStyles: {fontSize: 9},
  columnStyles: {0: {fontStyle: 'bold', cellWidth: 80}, 1: {cellWidth: 90}},
  margin: {left: 20, right: 20}
 });
 
 y = doc.lastAutoTable.finalY + 10;
 
 // Produtos e Consumo
 doc.setTextColor(26,58,92);
 doc.setFontSize(12);
 doc.setFont('helvetica','bold');
 doc.text('PRODUTOS E CONSUMO MENSAL',20,y);
 y += 5;
 
 // Montar dados da tabela
 const produtos = [];
 const resultDiv = document.getElementById('calc-resultado');
 if(resultDiv){
  const items = resultDiv.querySelectorAll('.calc-item');
  items.forEach(item=>{
   const tituloRaw = item.querySelector('h4')?.textContent || '';
   const titulo = tituloRaw.replace(/[\u{1F300}-\u{1F9FF}]/ug,'').replace(/[^\w\sÀ-ÿ]/g,'').trim();
   const rows = item.querySelectorAll('.calc-row');
   let produto = '', consumo = '', custo = '', dispensers = '';
   
   rows.forEach(row=>{
    const label = row.querySelector('span:first-child')?.textContent?.trim() || '';
    const valorSpan = row.querySelector('span:last-child');
    const valorStrong = row.querySelector('strong');
    const valor = (valorStrong?.textContent || valorSpan?.textContent || '').trim();
    
    if(label.includes('Produto')) produto = valor;
    else if(label.includes('Consumo')) consumo = valor;
    else if(label.includes('Custo')) custo = valor;
    else if(label.includes('Dispensers')){
     dispensers = valor.replace(/[\u{1F300}-\u{1F9FF}]/ug,'').replace('(Comodato Gratis)','').trim();
    }
   });
   
   if(produto) produtos.push([titulo, produto, consumo, custo, dispensers]);
  });
 }
 
 doc.autoTable({
  startY: y,
  head: [['Categoria','Produto','Consumo','Custo','Dispensers']],
  body: produtos,
  theme: 'striped',
  headStyles: {fillColor: [26,58,92], fontSize: 7.5, fontStyle: 'bold'},
  bodyStyles: {fontSize: 7},
  columnStyles: {
   0: {cellWidth: 28, fontStyle: 'bold'},
   1: {cellWidth: 65},
   2: {cellWidth: 20},
   3: {cellWidth: 23},
   4: {cellWidth: 34}
  },
  margin: {left: 20, right: 20}
 });
 
 y = doc.lastAutoTable.finalY + 10;
 
 // Total
 const totalDiv = resultDiv?.querySelector('.calc-total');
 if(totalDiv){
  const totalRaw = totalDiv.childNodes[0]?.textContent?.trim() || '';
  const totalText = totalRaw.replace(/[\u{1F300}-\u{1F9FF}]/ug,'').replace(/[^\w\s:R$.,]/g,'').trim();
  
  const comodatoRaw = totalDiv.querySelector('div')?.textContent || '';
  const comodatoText = comodatoRaw.replace(/[\u{1F300}-\u{1F9FF}]/ug,'').replace(/[^\w\sÀ-ÿ]/g,'').trim();
  
  doc.setFillColor(26,58,92);
  doc.rect(20,y,170,18,'F');
  doc.setTextColor(255,255,255);
  doc.setFontSize(13);
  doc.setFont('helvetica','bold');
  doc.text(totalText,105,y+8,{align:'center'});
  doc.setFontSize(9);
  doc.setFont('helvetica','normal');
  doc.text(comodatoText,105,y+14,{align:'center'});
 }
 
 // Footer
 doc.setTextColor(100,100,100);
 doc.setFontSize(8);
 doc.text('Jori Papel - (21) 99189-3818 - contato@joripapel.com.br',105,285,{align:'center'});
 
 doc.save(`Planejamento-Comodato-${new Date().toISOString().split('T')[0]}.pdf`);
}

// Calculadora de Economia vs Concorrente
function calcularEconomiaConcorrente(){
 const numDisp = parseInt(document.getElementById('calc-disp-concorrente').value) || 10;
 const concorrente = document.getElementById('calc-concorrente').value;
 const gastoAtual = parseFloat(document.getElementById('calc-gasto-atual').value) || 2000;
 
 // Percentuais médios de economia e custos de dispenser por concorrente
 let percEconomiaRefil = 0.25; // KC/Elite média 25%
 let custoDispMensal = 20; // Padrão KC
 
 if(concorrente === 'tork'){
  percEconomiaRefil = 0.35; // Tork é 35% mais caro
  custoDispMensal = 25; // Tork cobra R$ 25/mês ou lock-in
 } else if(concorrente === 'elite'){
  percEconomiaRefil = 0.22; // Elite 22% mais caro
  custoDispMensal = 18; // Elite cobra R$ 15-20/mês
 } else if(concorrente === 'softys'){
  percEconomiaRefil = 0.15; // Softys 15% economia (competitivo)
  custoDispMensal = 10; // Softys tem comodato limitado
 } else if(concorrente === 'suzano'){
  percEconomiaRefil = 0.12; // Suzano preço parecido
  custoDispMensal = 0; // Suzano geralmente não oferece comodato
 }
 
 // Cálculos
 const economiaRefil = gastoAtual * percEconomiaRefil;
 const economiaDisp = numDisp * custoDispMensal;
 const economiaMensal = economiaRefil + economiaDisp;
 const economiaAnual = economiaMensal * 12;
 const economiaDispAnual = economiaDisp * 12;
 
 // Mostrar resultados
 document.getElementById('eco-mensal').textContent = `R$ ${economiaMensal.toFixed(2)}`;
 document.getElementById('eco-anual').textContent = `R$ ${economiaAnual.toFixed(2)}`;
 document.getElementById('eco-disp').textContent = `R$ ${economiaDispAnual.toFixed(2)}`;
 document.getElementById('qtd-disp').textContent = numDisp;
 document.getElementById('resultado-economia').style.display = 'block';
}

// Inicializar calculadora ao abrir
if(document.getElementById('calc-colab')){
 atualizarProdutosToalha();
 atualizarProdutosHigienico();
}

// ===========================
// CRM - AUTENTICAÇÃO
// ===========================

// Usuários do sistema (email => {nome, senha, vendedor, isAdmin, primeiroAcesso})
function carregarUsuarios(){
 const dados = localStorage.getItem('joriCrmUsuarios');
 if(dados) return JSON.parse(dados);
 
 // Inicializar usuários padrão na primeira vez
 const usuariosPadrao = {
  'rackel@joripapel.com.br': {nome:'Rackel', senha:'Jori123', vendedor:'Rackel', isAdmin:false, primeiroAcesso:true},
  'debora@joripapel.com.br': {nome:'Débora', senha:'Jori123', vendedor:'Débora', isAdmin:false, primeiroAcesso:true},
  'biancalima@joripapel.com.br': {nome:'Bianca', senha:'Jori123', vendedor:'Bianca', isAdmin:false, primeiroAcesso:true},
  'andrea@joripapel.com.br': {nome:'Andrea', senha:'Jori123', vendedor:'Andrea', isAdmin:false, primeiroAcesso:true},
  'joaoricardomota@joripapel.com.br': {nome:'João Ricardo (Admin)', senha:'Jori123', vendedor:null, isAdmin:true, primeiroAcesso:true}
 };
 localStorage.setItem('joriCrmUsuarios', JSON.stringify(usuariosPadrao));
 return usuariosPadrao;
}

function salvarUsuarios(usuarios){
 localStorage.setItem('joriCrmUsuarios', JSON.stringify(usuarios));
}

// Sessão ativa (email do usuário logado)
function getSessaoAtiva(){
 return localStorage.getItem('joriCrmSessao');
}

function setSessaoAtiva(email){
 localStorage.setItem('joriCrmSessao', email);
}

function limparSessao(){
 localStorage.removeItem('joriCrmSessao');
}

// Fazer login
function fazerLogin(event){
 event.preventDefault();
 
 const email = document.getElementById('loginEmail').value.trim().toLowerCase();
 const senha = document.getElementById('loginSenha').value;
 const usuarios = carregarUsuarios();
 
 const usuario = usuarios[email];
 
 if(!usuario || usuario.senha !== senha){
  document.getElementById('loginErro').textContent = '❌ E-mail ou senha incorretos';
  document.getElementById('loginErro').style.display = 'block';
  return;
 }
 
 // Login bem-sucedido
 setSessaoAtiva(email);
 
 // Se for primeiro acesso, forçar troca de senha
 if(usuario.primeiroAcesso){
  mostrarCrmConteudo();
  setTimeout(() => {
   alert('⚠️ Primeiro acesso detectado!\n\nPor favor, altere sua senha padrão para maior segurança.');
   abrirModalTrocarSenha();
  }, 500);
 } else {
  mostrarCrmConteudo();
 }
}

// Fazer logout
function fazerLogout(){
 if(confirm('Tem certeza que deseja sair?')){
  limparSessao();
  mostrarTelaLogin();
 }
}

// Mostrar tela de login
function mostrarTelaLogin(){
 document.getElementById('crmLogin').style.display = 'block';
 document.getElementById('crmConteudo').style.display = 'none';
 document.getElementById('loginEmail').value = '';
 document.getElementById('loginSenha').value = '';
 document.getElementById('loginErro').style.display = 'none';
}

// Mostrar conteúdo CRM (após login)
function mostrarCrmConteudo(){
 const email = getSessaoAtiva();
 const usuarios = carregarUsuarios();
 const usuario = usuarios[email];
 
 if(!usuario){
  mostrarTelaLogin();
  return;
 }
 
 document.getElementById('crmLogin').style.display = 'none';
 document.getElementById('crmConteudo').style.display = 'block';
 
 // Atualizar info do usuário logado
 const textoUsuario = usuario.isAdmin 
  ? `👤 ${usuario.nome} - Visualizando todos os leads`
  : `👤 ${usuario.nome} - Seus leads`;
 document.getElementById('crmUsuarioLogado').textContent = textoUsuario;
 
 // Ocultar filtro de vendedor se não for admin
 const filterVendedor = document.getElementById('crmFilterVendedor');
 if(!usuario.isAdmin){
  filterVendedor.style.display = 'none';
 } else {
  filterVendedor.style.display = '';
 }
 
 // Renderizar funil com permissões
 renderFunil();
 atualizarMetricas();
}

// Abrir modal trocar senha
function abrirModalTrocarSenha(){
 document.getElementById('modalTrocarSenha').style.display = 'block';
 document.getElementById('formTrocarSenha').reset();
 document.getElementById('senhaErro').style.display = 'none';
}

// Fechar modal trocar senha
function fecharModalTrocarSenha(){
 document.getElementById('modalTrocarSenha').style.display = 'none';
}

// Trocar senha
function trocarSenha(event){
 event.preventDefault();
 
 const email = getSessaoAtiva();
 const usuarios = carregarUsuarios();
 const usuario = usuarios[email];
 
 const senhaAtual = document.getElementById('senhaAtual').value;
 const senhaNova = document.getElementById('senhaNova').value;
 const senhaConfirma = document.getElementById('senhaConfirma').value;
 
 // Validações
 if(usuario.senha !== senhaAtual){
  document.getElementById('senhaErro').textContent = '❌ Senha atual incorreta';
  document.getElementById('senhaErro').style.display = 'block';
  return;
 }
 
 if(senhaNova.length < 6){
  document.getElementById('senhaErro').textContent = '❌ A nova senha deve ter no mínimo 6 caracteres';
  document.getElementById('senhaErro').style.display = 'block';
  return;
 }
 
 if(senhaNova !== senhaConfirma){
  document.getElementById('senhaErro').textContent = '❌ As senhas não coincidem';
  document.getElementById('senhaErro').style.display = 'block';
  return;
 }
 
 // Atualizar senha
 usuario.senha = senhaNova;
 usuario.primeiroAcesso = false;
 salvarUsuarios(usuarios);
 
 alert('✅ Senha alterada com sucesso!');
 fecharModalTrocarSenha();
}

// Verificar autenticação ao abrir a aba CRM
function verificarAutenticacao(){
 const email = getSessaoAtiva();
 const usuarios = carregarUsuarios();
 
 if(email && usuarios[email]){
  mostrarCrmConteudo();
 } else {
  mostrarTelaLogin();
 }
}

// ===========================
// CRM - FUNIL DE VENDAS
// ===========================

const VENDEDORES = {
 Bianca: '#3b82f6',   // Azul
 Rackel: '#ec4899',   // Rosa
 Débora: '#a855f7',   // Roxo
 Andrea: '#f59e0b',   // Laranja
 Patrícia: '#10b981'  // Verde
};

const ETAPAS = {
 lead: {nome:'Lead',icon:'🎯',cor:'#94a3b8'},
 qualificado: {nome:'Qualificado',icon:'✅',cor:'#3b82f6'},
 proposta: {nome:'Proposta Enviada',icon:'📄',cor:'#f59e0b'},
 negociacao: {nome:'Em Negociação',icon:'💬',cor:'#a855f7'},
 ganho: {nome:'Fechado (Ganho)',icon:'🎉',cor:'#10b981'},
 perdido: {nome:'Fechado (Perdido)',icon:'❌',cor:'#ef4444'}
};

// Carregar leads do localStorage
function carregarLeads(){
 const dados = localStorage.getItem('joriCrmLeads');
 return dados ? JSON.parse(dados) : [];
}

// Salvar leads no localStorage
function salvarLeadsStorage(leads){
 localStorage.setItem('joriCrmLeads', JSON.stringify(leads));
}

// Abrir modal para novo lead
function abrirModalLead(leadId = null){
 const email = getSessaoAtiva();
 const usuarios = carregarUsuarios();
 const usuario = usuarios[email];
 
 const modal = document.getElementById('modalLead');
 const form = document.getElementById('formLead');
 const title = document.getElementById('modalLeadTitle');
 const selectVendedor = document.getElementById('leadVendedor');
 
 form.reset();
 
 if(leadId){
  // Editar lead existente
  const leads = carregarLeads();
  const lead = leads.find(l => l.id === leadId);
  if(!lead) return;
  
  title.textContent = '✏️ Editar Lead';
  document.getElementById('leadId').value = lead.id;
  document.getElementById('leadNome').value = lead.nome;
  document.getElementById('leadTelefone').value = lead.telefone;
  document.getElementById('leadEmail').value = lead.email || '';
  document.getElementById('leadSegmento').value = lead.segmento;
  document.getElementById('leadValor').value = lead.valor || '';
  document.getElementById('leadVendedor').value = lead.vendedor;
  document.getElementById('leadEtapa').value = lead.etapa;
  document.getElementById('leadObs').value = lead.obs || '';
 } else {
  // Novo lead
  title.textContent = '➕ Novo Lead';
  document.getElementById('leadId').value = '';
  document.getElementById('leadEtapa').value = 'lead';
  
  // Se não é admin, pré-selecionar vendedor e bloquear campo
  if(!usuario.isAdmin){
   selectVendedor.value = usuario.vendedor;
  }
 }
 
 // Se não é admin, desabilitar select de vendedor
 selectVendedor.disabled = !usuario.isAdmin;
 if(!usuario.isAdmin){
  selectVendedor.style.background = '#f3f4f6';
  selectVendedor.style.cursor = 'not-allowed';
 } else {
  selectVendedor.style.background = '';
  selectVendedor.style.cursor = '';
 }
 
 modal.style.display = 'block';
}

// Fechar modal
function fecharModalLead(){
 document.getElementById('modalLead').style.display = 'none';
}

// Salvar lead (criar ou editar)
function salvarLead(event){
 event.preventDefault();
 
 const id = document.getElementById('leadId').value;
 const nome = document.getElementById('leadNome').value.trim();
 const telefone = document.getElementById('leadTelefone').value.trim();
 const email = document.getElementById('leadEmail').value.trim();
 const segmento = document.getElementById('leadSegmento').value;
 const valor = parseFloat(document.getElementById('leadValor').value) || 0;
 const vendedor = document.getElementById('leadVendedor').value;
 const etapa = document.getElementById('leadEtapa').value;
 const obs = document.getElementById('leadObs').value.trim();
 
 let leads = carregarLeads();
 
 if(id){
  // Editar existente
  const index = leads.findIndex(l => l.id === id);
  if(index !== -1){
   leads[index] = {
    ...leads[index],
    nome,
    telefone,
    email,
    segmento,
    valor,
    vendedor,
    etapa,
    obs,
    updatedAt: Date.now()
   };
  }
 } else {
  // Criar novo
  const novoLead = {
   id: 'lead_' + Date.now() + '_' + Math.random().toString(36).substr(2,9),
   nome,
   telefone,
   email,
   segmento,
   valor,
   vendedor,
   etapa,
   obs,
   createdAt: Date.now(),
   updatedAt: Date.now()
  };
  leads.push(novoLead);
 }
 
 salvarLeadsStorage(leads);
 fecharModalLead();
 renderFunil();
 atualizarMetricas();
}

// Excluir lead
function excluirLead(leadId){
 if(!confirm('Tem certeza que deseja excluir este lead?')) return;
 
 let leads = carregarLeads();
 leads = leads.filter(l => l.id !== leadId);
 salvarLeadsStorage(leads);
 renderFunil();
 atualizarMetricas();
}

// Mover lead para outra etapa
function moverLead(leadId, novaEtapa){
 let leads = carregarLeads();
 const index = leads.findIndex(l => l.id === leadId);
 if(index !== -1){
  leads[index].etapa = novaEtapa;
  leads[index].updatedAt = Date.now();
  salvarLeadsStorage(leads);
  renderFunil();
  atualizarMetricas();
 }
}

// Renderizar funil Kanban
function renderFunil(){
 const email = getSessaoAtiva();
 const usuarios = carregarUsuarios();
 const usuario = usuarios[email];
 
 if(!usuario) return;
 
 const leads = carregarLeads();
 const filterVendedor = document.getElementById('crmFilterVendedor').value;
 const filterEtapa = document.getElementById('crmFilterEtapa').value;
 
 // Filtrar leads (aplicar permissão: vendedor vê só seus leads, admin vê todos)
 let leadsFiltrados = leads.filter(l => {
  // Se não é admin, só mostra leads do próprio vendedor
  if(!usuario.isAdmin && l.vendedor !== usuario.vendedor) return false;
  
  // Aplicar filtros de UI
  if(filterVendedor && l.vendedor !== filterVendedor) return false;
  if(filterEtapa && l.etapa !== filterEtapa) return false;
  return true;
 });
 
 const funil = document.getElementById('crmFunil');
 funil.innerHTML = '';
 
 // Criar colunas para cada etapa
 Object.keys(ETAPAS).forEach(etapaKey => {
  const etapa = ETAPAS[etapaKey];
  const leadsEtapa = leadsFiltrados.filter(l => l.etapa === etapaKey);
  
  const coluna = document.createElement('div');
  coluna.className = 'card';
  coluna.style.background = '#f9fafb';
  coluna.style.minHeight = '400px';
  
  // Header da coluna
  const header = `
   <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;padding-bottom:12px;border-bottom:3px solid ${etapa.cor}">
    <div style="display:flex;align-items:center;gap:8px">
     <span style="font-size:1.3rem">${etapa.icon}</span>
     <span style="font-weight:700;font-size:1rem">${etapa.nome}</span>
    </div>
    <div style="background:${etapa.cor};color:#fff;padding:4px 12px;border-radius:12px;font-size:.85rem;font-weight:600">
     ${leadsEtapa.length}
    </div>
   </div>
  `;
  
  // Cards de leads
  const cardsHtml = leadsEtapa.map(lead => {
   const corVendedor = VENDEDORES[lead.vendedor] || '#64748b';
   const valorTexto = lead.valor > 0 ? `R$ ${lead.valor.toLocaleString('pt-BR',{minimumFractionDigits:2})}` : 'Não informado';
   
   return `
    <div style="background:#fff;border:1px solid #e5e7eb;border-left:4px solid ${corVendedor};border-radius:8px;padding:12px;margin-bottom:12px;cursor:pointer;transition:all .2s" onclick="abrirModalLead('${lead.id}')">
     <div style="display:flex;align-items:start;justify-content:space-between;margin-bottom:8px">
      <div style="font-weight:700;font-size:.95rem;flex:1">${lead.nome}</div>
      <button onclick="event.stopPropagation();excluirLead('${lead.id}')" style="background:none;border:none;color:#ef4444;font-size:1.1rem;cursor:pointer;padding:0;line-height:1" title="Excluir">×</button>
     </div>
     <div style="color:var(--muted);font-size:.8rem;margin-bottom:4px">${lead.segmento}</div>
     <div style="display:flex;align-items:center;gap:6px;margin-bottom:8px">
      <span style="background:${corVendedor};color:#fff;padding:2px 8px;border-radius:4px;font-size:.75rem;font-weight:600">${lead.vendedor}</span>
      <span style="color:var(--muted);font-size:.75rem">📞 ${lead.telefone}</span>
     </div>
     <div style="font-weight:600;color:${etapa.cor};font-size:.9rem;margin-bottom:8px">💰 ${valorTexto}</div>
     ${lead.obs ? `<div style="color:var(--muted);font-size:.75rem;border-top:1px solid #e5e7eb;padding-top:8px;margin-top:8px">${lead.obs}</div>` : ''}
     ${etapaKey !== 'ganho' && etapaKey !== 'perdido' ? `
      <div style="display:flex;gap:4px;margin-top:8px;flex-wrap:wrap">
       ${etapaKey === 'lead' ? `<button onclick="event.stopPropagation();moverLead('${lead.id}','qualificado')" style="flex:1;padding:4px 8px;background:#3b82f6;color:#fff;border:none;border-radius:4px;font-size:.7rem;cursor:pointer">→ Qualificar</button>` : ''}
       ${etapaKey === 'qualificado' ? `<button onclick="event.stopPropagation();moverLead('${lead.id}','proposta')" style="flex:1;padding:4px 8px;background:#f59e0b;color:#fff;border:none;border-radius:4px;font-size:.7rem;cursor:pointer">→ Proposta</button>` : ''}
       ${etapaKey === 'proposta' ? `<button onclick="event.stopPropagation();moverLead('${lead.id}','negociacao')" style="flex:1;padding:4px 8px;background:#a855f7;color:#fff;border:none;border-radius:4px;font-size:.7rem;cursor:pointer">→ Negociar</button>` : ''}
       ${etapaKey === 'negociacao' ? `
        <button onclick="event.stopPropagation();moverLead('${lead.id}','ganho')" style="flex:1;padding:4px 8px;background:#10b981;color:#fff;border:none;border-radius:4px;font-size:.7rem;cursor:pointer">✓ Ganho</button>
        <button onclick="event.stopPropagation();moverLead('${lead.id}','perdido')" style="flex:1;padding:4px 8px;background:#ef4444;color:#fff;border:none;border-radius:4px;font-size:.7rem;cursor:pointer">✗ Perdido</button>
       ` : ''}
      </div>
     ` : ''}
    </div>
   `;
  }).join('');
  
  coluna.innerHTML = header + (cardsHtml || '<div style="text-align:center;color:var(--muted);padding:20px;font-size:.85rem">Nenhum lead nesta etapa</div>');
  funil.appendChild(coluna);
 });
}

// Atualizar métricas principais
function atualizarMetricas(){
 const email = getSessaoAtiva();
 const usuarios = carregarUsuarios();
 const usuario = usuarios[email];
 
 if(!usuario) return;
 
 let leads = carregarLeads();
 
 // Aplicar filtro de permissão (vendedor vê só seus leads)
 if(!usuario.isAdmin){
  leads = leads.filter(l => l.vendedor === usuario.vendedor);
 }
 
 const leadsAtivos = leads.filter(l => l.etapa !== 'ganho' && l.etapa !== 'perdido');
 const leadsGanhos = leads.filter(l => l.etapa === 'ganho');
 const leadsPerdidos = leads.filter(l => l.etapa === 'perdido');
 const totalFechados = leadsGanhos.length + leadsPerdidos.length;
 
 // Total de leads ativos
 document.getElementById('crmTotalLeads').textContent = leadsAtivos.length;
 
 // Taxa de conversão
 const taxaConversao = totalFechados > 0 ? (leadsGanhos.length / totalFechados * 100).toFixed(1) : 0;
 document.getElementById('crmTaxaConversao').textContent = taxaConversao + '%';
 
 // Ticket médio (só leads ganhos com valor)
 const valoresGanhos = leadsGanhos.filter(l => l.valor > 0).map(l => l.valor);
 const ticketMedio = valoresGanhos.length > 0 ? valoresGanhos.reduce((a,b) => a+b, 0) / valoresGanhos.length : 0;
 document.getElementById('crmTicketMedio').textContent = ticketMedio.toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
}

// Inicializar CRM ao carregar
if(document.getElementById('crmFunil')){
 verificarAutenticacao();
}

// ===========================
// DIAGNÓSTICO DE DORES
// ===========================

const SOLUCOES_DIAG = {
 desperdicio: {
  titulo: "Desperdício Absurdo de Papel",
  problema: "Seu papel some em 2 dias porque as pessoas usam demais",
  solucao: "Dispensers com controle de folhas que reduzem consumo em até 40%",
  produtos: [
   {nome: "Dispenser Quartz para Toalha Interfolhada", linha: "Quartz", beneficio: "Libera 1 folha por vez, impossível pegar várias. Redução comprovada de 40% no consumo.", specs: "Compatível com ETI21, ITI01, ITI03, TSP04"},
   {nome: "Higiênico Rolão Personal Prof. (300m)", linha: "Personal Prof.", beneficio: "300 metros = dura 3x mais que rolo comum. Menos trocas, menos desperdício, menos custo.", specs: "PHR25 - rendimento até 85% superior"},
   {nome: "Toalha Interfolhada TSP04 (2.500 folhas)", linha: "Gala", beneficio: "Caixa com 2.500 folhas de alta absorção. Uma folha faz o trabalho de 3 comuns.", specs: "Gofrada dupla, luxo e economia"}
  ]
 },
 falta: {
  titulo: "Falta de Papel nos Banheiros",
  problema: "Cliente reclama que não tem papel, funcionário esquece de repor",
  solucao: "Rolos gigantes que duram semanas + indicador visual de nível",
  produtos: [
   {nome: "Higiênico Rolão EHR50 (300m)", linha: "Eco", beneficio: "300 metros = 6 rolos comuns. Dura até 1 semana em banheiro de alto fluxo. Funcionário só precisa checar 1x por semana.", specs: "EHR50 - 8 rolos por caixa"},
   {nome: "Dispenser Elegance com Visor Transparente", linha: "Elegance", beneficio: "Visor mostra quanto tem de papel. Equipe vê de longe se precisa repor. Nunca mais pega desprevenido.", specs: "Para rolão 300m"},
   {nome: "Bobina RTB01 (300m)", linha: "Reviva", beneficio: "300 metros sustentáveis. Ideal para áreas de muito movimento. Reposição semanal.", specs: "RTB01 - 100% fibra reciclada"}
  ]
 },
 roubo: {
  titulo: "Roubo de Papel pelos Usuários",
  problema: "Pessoas levam rolos inteiros, vandalismo, estoque desaparece",
  solucao: "Dispensers trancados com chave + rolos gigantes internos difíceis de remover",
  produtos: [
   {nome: "Dispenser Quartz Trancado", linha: "Quartz", beneficio: "Trava com chave. Impossível abrir sem autorização. Design anti-vandalismo em ABS reforçado.", specs: "Resistente a impactos"},
   {nome: "Dispenser Titanium Heavy Duty", linha: "Titanium", beneficio: "Metal reforçado, parafusos anti-furto. Feito para ambientes agressivos (estações, eventos, áreas públicas).", specs: "Garantia 5 anos"},
   {nome: "Higiênico Rolão 300m Interno", linha: "Eco/Personal", beneficio: "Rolo gigante fica dentro do dispenser trancado. Usuário não vê, não mexe, não leva embora.", specs: "EHR50 ou PHR25"}
  ]
 },
 sujeira: {
  titulo: "Banheiros Sempre Sujos",
  problema: "Papel usado jogado no chão, pia molhada, reclamações de falta de higiene",
  solucao: "Papel toalha de alta absorção que seca de verdade + lixeiras específicas",
  produtos: [
   {nome: "Toalha Interfolhada Gala TSP04", linha: "Gala", beneficio: "Absorção premium. 1 folha seca as mãos completamente. Pessoa não precisa pegar 10 folhas, não desperdiça, não suja o chão.", specs: "Gofrada dupla, macia e super absorvente"},
   {nome: "Bobina de Toalha RTI01", linha: "Reviva", beneficio: "Rolo contínuo, corte controlado. Menos resíduos, menos papel no chão.", specs: "RTI01 - 100% reciclada"},
   {nome: "Sabonete Líquido SEAQ (Quartz)", linha: "Quartz", beneficio: "Espuma cremosa, não pinga, não suja pia. Usuário lava as mãos direito, seca direito, sai limpo.", specs: "SEAQ - 800ml, erva-doce"}
  ]
 },
 custo: {
  titulo: "Custo Muito Alto com Higiene",
  problema: "Gasto excessivo comprando papel, sabonete, produtos. Orçamento estourado",
  solucao: "Produtos de altíssimo rendimento + comodato gratuito de dispensers",
  produtos: [
   {nome: "Higiênico Rolão Personal 300m", linha: "Personal Prof.", beneficio: "Rendimento 85% superior ao rolo comum. Você compra 1, rende como 1,85. Economia direta no bolso.", specs: "PHR25 - custo por uso 50% menor"},
   {nome: "Toalha Interfolhada ETI21 Eco", linha: "Eco", beneficio: "Versão econômica com qualidade. Caixa com 2.000 folhas. Custo-benefício imbatível.", specs: "ETI21 - linha mais vendida"},
   {nome: "Comodato Gratuito de Dispensers", linha: "Todas", beneficio: "Jori Papel empresta os dispensers de graça. Você só paga o refil. Zero investimento inicial, zero custo de manutenção.", specs: "Quartz, Elegance, Titanium - todos inclusos"}
  ]
 },
 qualidade: {
  titulo: "Papel de Baixa Qualidade",
  problema: "Rasga fácil, absorção ruim, clientes reclamam, não passa imagem premium",
  solucao: "Linha Gala e Personal Prof. - máxima qualidade e maciez",
  produtos: [
   {nome: "Toalha Gala TSP04 - Linha Premium", linha: "Gala", beneficio: "Gofrada dupla, maciez de hotel 5 estrelas. Absorção instantânea. Cliente seca as mãos e sente a qualidade.", specs: "TSP04 - a melhor da Santher"},
   {nome: "Higiênico Personal Prof. PHR25", linha: "Personal Prof.", beneficio: "Folha dupla, macio como algodão. Experiência premium em cada uso. Comunica padrão alto do estabelecimento.", specs: "PHR25 - 300m de luxo"},
   {nome: "Guardanapo Gala Premium", linha: "Gala", beneficio: "Para restaurantes que querem impressionar. Guardanapo de alta gramatura, gofrado, toque premium.", specs: "GGG40 - sensação de restaurante fino"}
  ]
 }
};

let doresSelecionadasDiag = new Set();

function toggleDor(dor) {
 const card = document.querySelector(`[data-dor="${dor}"]`);
 
 if (doresSelecionadasDiag.has(dor)) {
  doresSelecionadasDiag.delete(dor);
  card.style.border = '2px solid #e5e7eb';
  card.style.background = '#fff';
 } else {
  doresSelecionadasDiag.add(dor);
  card.style.border = '2px solid #a855f7';
  card.style.background = '#f5f3ff';
 }
 
 atualizarBotaoDiag();
}

function atualizarBotaoDiag() {
 const btn = document.getElementById('btnVerSolucoesDiag');
 const contador = document.getElementById('contadorDoresDiag');
 const qtd = doresSelecionadasDiag.size;
 
 if (qtd > 0) {
  btn.disabled = false;
  btn.style.opacity = '1';
  contador.textContent = `${qtd} dor${qtd > 1 ? 'es' : ''} selecionada${qtd > 1 ? 's' : ''} - Clique para ver soluções`;
  contador.style.color = '#a855f7';
  contador.style.fontWeight = '600';
 } else {
  btn.disabled = true;
  btn.style.opacity = '0.5';
  contador.textContent = 'Selecione pelo menos 1 dor para continuar';
  contador.style.color = 'var(--muted)';
  contador.style.fontWeight = '400';
 }
}

function mostrarSolucoesDiag() {
 if (doresSelecionadasDiag.size === 0) return;
 
 const container = document.getElementById('containerSolucoesDiag');
 container.innerHTML = '';
 container.style.display = 'block';
 
 // Header de soluções
 const header = document.createElement('div');
 header.className = 'card';
 header.style.background = 'linear-gradient(135deg,#10b981,#059669)';
 header.style.color = '#fff';
 header.style.padding = '24px';
 header.style.textAlign = 'center';
 header.style.marginBottom = '24px';
 header.innerHTML = `
  <h3 style="font-size:1.8rem;margin-bottom:8px;color:#fff">✅ Soluções Encontradas!</h3>
  <p style="opacity:.9;font-size:1.1rem">Produtos Santher Professional que resolvem suas ${doresSelecionadasDiag.size} dor${doresSelecionadasDiag.size > 1 ? 'es' : ''} selecionada${doresSelecionadasDiag.size > 1 ? 's' : ''}</p>
 `;
 container.appendChild(header);
 
 doresSelecionadasDiag.forEach(dorKey => {
  const solucao = SOLUCOES_DIAG[dorKey];
  if (!solucao) return;
  
  const dorDiv = document.createElement('div');
  dorDiv.style.marginBottom = '24px';
  
  const produtosHtml = solucao.produtos.map(prod => `
   <div class="card" style="border-left:4px solid #a855f7;background:#f9fafb">
    <div style="display:flex;justify-content:space-between;align-items:start;margin-bottom:12px">
     <h5 style="font-size:1rem;font-weight:700;color:var(--pri)">${prod.nome}</h5>
     <span style="background:#a855f7;color:#fff;padding:4px 10px;border-radius:12px;font-size:.7rem;font-weight:600">${prod.linha}</span>
    </div>
    <p style="color:var(--text);margin-bottom:8px;line-height:1.6">${prod.beneficio}</p>
    <p style="color:var(--muted);font-size:.85rem;font-style:italic">${prod.specs}</p>
   </div>
  `).join('');
  
  dorDiv.innerHTML = `
   <div class="card" style="background:linear-gradient(135deg,#fef2f2,#fee2e2);border:2px solid #fca5a5">
    <div style="display:flex;align-items:start;gap:16px;margin-bottom:16px">
     <div style="font-size:3rem">⚠️</div>
     <div style="flex:1">
      <h4 style="font-size:1.3rem;font-weight:700;color:#991b1b;margin-bottom:8px">${solucao.titulo}</h4>
      <p style="color:#b91c1c;font-weight:600;margin-bottom:12px">❌ ${solucao.problema}</p>
      <div style="background:#dcfce7;border-left:4px solid #16a34a;padding:12px;border-radius:6px">
       <p style="color:#166534;font-weight:700">✅ ${solucao.solucao}</p>
      </div>
     </div>
    </div>
    
    <div style="margin-top:20px">
     <h5 style="font-size:1.1rem;font-weight:700;color:var(--pri);margin-bottom:12px">Produtos Santher Recomendados:</h5>
     <div style="display:grid;gap:12px">
      ${produtosHtml}
     </div>
    </div>
   </div>
  `;
  
  container.appendChild(dorDiv);
 });
 
 // CTA Final
 const cta = document.createElement('div');
 cta.className = 'card';
 cta.style.background = 'linear-gradient(135deg,var(--pri),var(--pri-light))';
 cta.style.color = '#fff';
 cta.style.padding = '32px';
 cta.style.textAlign = 'center';
 cta.innerHTML = `
  <h4 style="font-size:1.8rem;font-weight:700;margin-bottom:12px;color:#fff">Pronto para resolver suas dores?</h4>
  <p style="font-size:1.1rem;opacity:.9;margin-bottom:24px">Entre em contato e receba uma proposta personalizada Santher Professional</p>
  <div style="display:flex;flex-wrap:wrap;gap:12px;justify-content:center">
   <a href="https://wa.me/5521991893818?text=Olá! Fiz o diagnóstico de dores no app Jori e gostaria de receber uma proposta Santher Professional personalizada." target="_blank" class="btn" style="background:#25D366;padding:14px 24px;font-size:1rem;display:inline-flex;align-items:center;gap:8px">
    <svg style="width:20px;height:20px" fill="currentColor" viewBox="0 0 24 24">
     <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
    </svg>
    Falar pelo WhatsApp
   </a>
   <a href="tel:+5521991893818" class="btn" style="background:#fff;color:var(--pri);padding:14px 24px;font-size:1rem;display:inline-flex;align-items:center;gap:8px">
    <svg style="width:20px;height:20px" fill="none" stroke="currentColor" viewBox="0 0 24 24">
     <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
    </svg>
    (21) 99189-3818
   </a>
  </div>
 `;
 container.appendChild(cta);
 
 // Scroll suave para soluções
 setTimeout(() => {
  container.scrollIntoView({ behavior: 'smooth', block: 'start' });
 }, 100);
}

/* === NEXT BLOCK === */


// ── Sidebar mobile — funções globais (inline onclick) ──────────────────
function toggleSidebar() {
  var sidebar = document.querySelector('.sidebar');
  var overlay = document.querySelector('.sidebar-overlay');
  if (!sidebar) return;
  sidebar.classList.toggle('open');
  if (overlay) overlay.classList.toggle('open');
}
function closeSidebar() {
  var sidebar = document.querySelector('.sidebar');
  var overlay = document.querySelector('.sidebar-overlay');
  if (sidebar) sidebar.classList.remove('open');
  if (overlay) overlay.classList.remove('open');
}

// Fecha ao clicar no overlay
document.addEventListener('DOMContentLoaded', function() {
  var overlay = document.querySelector('.sidebar-overlay');
  if (overlay) overlay.addEventListener('click', closeSidebar);
});


/* === NEXT BLOCK === */


// Scroll to top button
window.addEventListener('DOMContentLoaded', function() {
  // Criar botão se não existir
  if (!document.querySelector('.scroll-to-top')) {
    const btn = document.createElement('button');
    btn.className = 'scroll-to-top';
    btn.innerHTML = '↑';
    btn.title = 'Voltar ao topo';
    document.body.appendChild(btn);
    
    // Mostrar/esconder ao scroll
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 500) {
        btn.classList.add('visible');
      } else {
        btn.classList.remove('visible');
      }
    });
    
    // Click handler
    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
});


/* === NEXT BLOCK === */


// Atualizar breadcrumb ao trocar seção
document.addEventListener('DOMContentLoaded', function() {
  const navItems = document.querySelectorAll('.nav-item');
  const breadcrumb = document.getElementById('breadcrumb-text');
  
  if (breadcrumb) {
    navItems.forEach(item => {
      item.addEventListener('click', function() {
        const text = this.querySelector('span:last-child').textContent;
        breadcrumb.textContent = text;
      });
    });
  }
});


/* === NEXT BLOCK === */


// Loading states utilities
window.LoadingStates = {
  // Mostrar loading em botão
  buttonLoading(btn, text = 'Carregando...') {
    if (typeof btn === 'string') btn = document.querySelector(btn);
    if (!btn) return;
    
    btn.dataset.originalText = btn.textContent;
    btn.textContent = text;
    btn.classList.add('loading');
    btn.disabled = true;
  },
  
  // Remover loading de botão
  buttonDone(btn) {
    if (typeof btn === 'string') btn = document.querySelector(btn);
    if (!btn) return;
    
    btn.textContent = btn.dataset.originalText || 'Concluído';
    btn.classList.remove('loading');
    btn.disabled = false;
  },
  
  // Mostrar progress bar
  showProgress() {
    const bar = document.getElementById('progressBar');
    if (bar) {
      bar.classList.add('loading');
      setTimeout(() => bar.classList.remove('loading'), 2000);
    }
  }
};

// Auto progress bar ao trocar seção
document.addEventListener('DOMContentLoaded', function() {
  const navItems = document.querySelectorAll('.nav-item');
  navItems.forEach(item => {
    item.addEventListener('click', () => LoadingStates.showProgress());
  });
});


/* === NEXT BLOCK === */


// Accordion functionality
document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.accordion-header');
  
  accordions.forEach(header => {
    header.addEventListener('click', function() {
      const item = this.parentElement;
      const isOpen = item.classList.contains('open');
      
      // Fecha todos
      document.querySelectorAll('.accordion-item').forEach(i => {
        i.classList.remove('open');
      });
      
      // Abre o clicado se estava fechado
      if (!isOpen) {
        item.classList.add('open');
      }
    });
  });
});


